import { jsx as e, jsxs as c, Fragment as be } from "react/jsx-runtime";
import * as j from "react";
import { useMemo as re, Suspense as Bt, useState as L, useRef as Ae, useEffect as oe, useCallback as fe, useId as Rt, createContext as $t, useContext as Ot } from "react";
import { Breadcrumb as zt, Card as Te, Layout as ie, theme as Y, Grid as Je, Spin as St, ConfigProvider as Wt, Tooltip as vt, Typography as F, Space as V, Tag as he, Button as E, Menu as Ge, Badge as qt, Avatar as wt, DatePicker as xt, Empty as Ht, Drawer as Vt, App as Se, Steps as et, Form as v, Select as Ie, InputNumber as tt, Modal as Me, Input as W, Popconfirm as jt, Alert as $e, Tree as Gt, Table as K, Descriptions as le, Divider as Yt, Row as Ye, Col as Oe, Progress as Kt, Radio as Le, Checkbox as De, Upload as Qt, Collapse as Xt } from "antd";
import { Link as ze, Outlet as Zt, useNavigate as nt } from "react-router-dom";
import { BellIcon as Jt, ChevronDownIcon as en } from "@heroicons/react/24/outline";
import { MenuUnfoldOutlined as tn, MenuFoldOutlined as nn, DeleteOutlined as kt, SearchOutlined as rn, DownloadOutlined as on, PrinterOutlined as an, InboxOutlined as ln, SunOutlined as sn, MoonOutlined as cn, FacebookFilled as dn, CheckCircleFilled as un } from "@ant-design/icons";
import ae from "dayjs";
import mn from "dayjs/plugin/isoWeek.js";
import { ResponsiveContainer as hn, BarChart as pn, XAxis as gn, YAxis as fn, Tooltip as yn, ReferenceLine as st, Bar as bn } from "recharts";
import { getMessage as d } from "@digiwedge/i18n-messages";
import { z as Sn } from "zod";
import { useMutation as vn, QueryClient as wn, QueryClientProvider as xn } from "@tanstack/react-query";
import { TenantsApi as kn } from "@digiwedge/access-control-api-client";
import { useTheme as Ct, useLocale as Cn } from "@digiwedge/ui-theme";
import { AppThemeProvider as Yi } from "@digiwedge/ui-theme";
import { useLogin as Tt, useVerifyLoginMfa as Tn, classifyAxiosError as _n, useRegister as _t, useLogout as Nn, useRegisterSmsMfa as An, useVerifySmsMfa as Ln } from "@digiwedge/hooks-auth-web";
import { isAxiosError as Dn } from "axios";
import { parseLocationForOAuthError as In } from "@digiwedge/oauth-redirect-utils";
const ri = ({
  breadcrumbItems: t = [],
  separator: n = ">",
  style: r = { margin: "16px 0" },
  renderItem: o
}) => {
  const i = re(() => t.map((l, u) => {
    const a = u === t.length - 1;
    let s;
    return o ? s = o(l, a) : a ? s = /* @__PURE__ */ e("span", { style: { fontWeight: "bold" }, children: l.name }) : s = l.path ? /* @__PURE__ */ e(ze, { to: l.path, children: l.name }) : l.name, { title: s };
  }), [t, o]);
  return /* @__PURE__ */ e(zt, { items: i, separator: n, style: r });
}, oi = ({ img: t, icon: n, title: r }) => /* @__PURE__ */ c(
  Te,
  {
    hoverable: !0,
    style: { width: "100%", borderRadius: 12 },
    bodyStyle: {
      padding: 12,
      display: "flex",
      alignItems: "center",
      gap: 4,
      whiteSpace: "nowrap"
    },
    cover: /* @__PURE__ */ e(
      "div",
      {
        style: {
          height: 120,
          backgroundImage: `url(${t})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }
      }
    ),
    children: [
      n,
      /* @__PURE__ */ e(
        "div",
        {
          style: {
            fontWeight: 600,
            fontSize: 14,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          },
          children: r
        }
      )
    ]
  }
), { Content: Mn } = ie, ii = ({
  children: t,
  padding: n,
  responsivePadding: r
}) => {
  const {
    token: { colorBgContainer: o }
  } = Y.useToken(), i = Je.useBreakpoint(), l = j.useMemo(() => {
    if (r) {
      const u = ["xxl", "xl", "lg", "md", "sm", "xs"];
      for (const a of u)
        if (i[a] && typeof r[a] == "number")
          return r[a];
    }
    return typeof n == "number" ? n : 24;
  }, [i, n, r]);
  return /* @__PURE__ */ e(
    Mn,
    {
      style: {
        padding: l,
        minHeight: "calc(100vh - 64px - 70px)",
        // Adjust for header and footer
        background: o
        // Dynamic background color based on theme
      },
      children: /* @__PURE__ */ e(
        Bt,
        {
          fallback: /* @__PURE__ */ e(
            St,
            {
              size: "large",
              style: {
                display: "block",
                margin: "auto",
                marginTop: "20%"
                // Center the spinner vertically
              }
            }
          ),
          children: t || /* @__PURE__ */ e(Zt, {})
        }
      )
    }
  );
}, xe = 48, Nt = "env(safe-area-inset-bottom)", ai = (t) => `calc(${t}px + ${Nt})`, { Footer: Un } = ie, En = {
  facebook: /* @__PURE__ */ e("i", { className: "fab fa-facebook" }),
  twitter: /* @__PURE__ */ e("i", { className: "fab fa-twitter" }),
  instagram: /* @__PURE__ */ e("i", { className: "fab fa-instagram" }),
  linkedin: /* @__PURE__ */ e("i", { className: "fab fa-linkedin" })
  // Add more icons as needed
}, Fn = ({
  text: t = "© 2025 DigiWedge. All rights reserved.",
  style: n,
  socialMedia: r = [],
  bgColor: o,
  borderColor: i,
  highlightColor: l,
  themeMode: u,
  brandName: a = "Tee Time",
  brandDescription: s = "Book tee times, discover golf clubs, and enjoy exclusive deals. Your perfect round starts here.",
  quickLinks: m = [
    { label: "Find Clubs", href: "/clubs" },
    { label: "Featured Deals", href: "/specials" },
    { label: "About Us", href: "/about" },
    { label: "Contact", href: "/contact" },
    { label: "FAQ", href: "/faq" }
  ],
  contactEmail: h = "support@teetime.com",
  contactPhone: g = "+1 234 567 890",
  showNewsletter: _ = !0,
  newsletterTitle: C = "Subscribe to our Newsletter",
  newsletterPlaceholder: f = "Your email",
  newsletterButtonLabel: S = "Subscribe"
}) => {
  const { token: b } = Y.useToken(), I = u ?? "light", p = u != null ? Y.getDesignToken({
    algorithm: I === "dark" ? Y.darkAlgorithm : Y.defaultAlgorithm
  }) : b, N = o ?? p.colorBgContainer, q = i ?? p.colorSplit ?? p.colorBorderSecondary, H = p.colorText, x = p.colorTextDescription ?? p.colorTextSecondary ?? H, P = l ?? p.colorPrimary, M = p.colorBgLayout, y = `clamp(${p.paddingSM}px, 6vw, ${p.paddingXL}px)`, D = m ?? [], A = D.length > 0, w = !!(h || g), U = {
    textAlign: "center",
    padding: 0,
    marginTop: p.marginXL,
    backgroundColor: N,
    color: H,
    borderTop: `1px solid ${q}`,
    ...n
  }, B = /* @__PURE__ */ c(Un, { style: { ...U }, children: [
    /* @__PURE__ */ c(
      "div",
      {
        style: {
          width: "100%",
          padding: `24px ${y}`,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: p.marginLG,
          minHeight: xe
        },
        children: [
          /* @__PURE__ */ c("div", { style: { marginBottom: p.marginMD, textAlign: "left", maxWidth: 320 }, children: [
            /* @__PURE__ */ e(
              "div",
              {
                style: {
                  fontWeight: 700,
                  fontSize: 22,
                  color: P,
                  marginBottom: p.marginSM
                },
                children: a
              }
            ),
            /* @__PURE__ */ e("div", { style: { color: x, fontSize: 14 }, children: s })
          ] }),
          A && /* @__PURE__ */ c("div", { style: { marginBottom: p.marginMD, textAlign: "left" }, children: [
            /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: p.marginSM }, children: "Quick Links" }),
            /* @__PURE__ */ e("div", { style: { display: "flex", flexDirection: "column", gap: 4 }, children: D.map((R) => /* @__PURE__ */ e("a", { href: R.href, style: { color: H }, children: R.label }, R.href)) })
          ] }),
          w && /* @__PURE__ */ c("div", { style: { marginBottom: p.marginMD, textAlign: "left" }, children: [
            /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: p.marginSM }, children: "Contact" }),
            /* @__PURE__ */ c("div", { style: { fontSize: 14 }, children: [
              h && /* @__PURE__ */ c(be, { children: [
                "Email:",
                " ",
                /* @__PURE__ */ e("a", { href: `mailto:${h}`, style: { color: P }, children: h })
              ] }),
              h && g && /* @__PURE__ */ e("br", {}),
              g && /* @__PURE__ */ c(be, { children: [
                "Phone:",
                " ",
                /* @__PURE__ */ e("a", { href: `tel:${g.replace(/\s/g, "")}`, style: { color: H }, children: g })
              ] })
            ] }),
            /* @__PURE__ */ e("div", { style: { marginTop: p.marginSM }, children: r.length > 0 ? r.map(
              (R) => R.href ? /* @__PURE__ */ e(
                "a",
                {
                  href: R.href,
                  "aria-label": R.platform,
                  style: { margin: "0 8px", color: P },
                  children: R.icon || En[R.platform.toLowerCase()]
                },
                R.href
              ) : null
            ) : /* @__PURE__ */ c(be, { children: [
              /* @__PURE__ */ e(
                "a",
                {
                  href: "https://facebook.com",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Facebook",
                  style: { margin: "0 8px", color: P },
                  children: /* @__PURE__ */ e("i", { className: "fab fa-facebook" })
                }
              ),
              /* @__PURE__ */ e(
                "a",
                {
                  href: "https://twitter.com",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Twitter",
                  style: { margin: "0 8px", color: P },
                  children: /* @__PURE__ */ e("i", { className: "fab fa-twitter" })
                }
              ),
              /* @__PURE__ */ e(
                "a",
                {
                  href: "https://instagram.com",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Instagram",
                  style: { margin: "0 8px", color: P },
                  children: /* @__PURE__ */ e("i", { className: "fab fa-instagram" })
                }
              )
            ] }) })
          ] }),
          _ && /* @__PURE__ */ c("div", { style: { marginBottom: p.marginMD, textAlign: "left" }, children: [
            /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: p.marginSM }, children: C }),
            /* @__PURE__ */ c(
              "form",
              {
                onSubmit: (R) => R.preventDefault(),
                style: { display: "flex", gap: p.marginSM, flexWrap: "wrap" },
                children: [
                  /* @__PURE__ */ e(
                    "input",
                    {
                      type: "email",
                      placeholder: f,
                      "aria-label": f,
                      style: {
                        flex: 1,
                        padding: 6,
                        borderRadius: p.borderRadius,
                        border: `1px solid ${p.colorBorder}`,
                        background: p.colorBgContainer,
                        color: H
                      }
                    }
                  ),
                  /* @__PURE__ */ e(
                    "button",
                    {
                      type: "submit",
                      style: {
                        background: P,
                        color: p.colorTextLightSolid,
                        border: "none",
                        borderRadius: p.borderRadius,
                        padding: "6px 14px",
                        fontWeight: 600,
                        cursor: "pointer"
                      },
                      children: S
                    }
                  )
                ]
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ e(
      "div",
      {
        style: {
          color: x,
          fontSize: 13,
          padding: "16px 0",
          width: "100%",
          backgroundColor: M
        },
        children: /* @__PURE__ */ c(
          "div",
          {
            style: {
              width: "100%",
              padding: `0 ${y}`,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              rowGap: p.marginSM,
              whiteSpace: "nowrap"
            },
            children: [
              /* @__PURE__ */ e("p", { style: { margin: 0 }, children: t }),
              /* @__PURE__ */ e("div", { style: { width: "100%" } }),
              /* @__PURE__ */ c("div", { style: { display: "flex", gap: 16, whiteSpace: "nowrap" }, children: [
                /* @__PURE__ */ e("a", { href: "/terms", style: { color: x }, children: "Terms of Service" }),
                /* @__PURE__ */ e("a", { href: "/privacy", style: { color: x }, children: "Privacy Policy" })
              ] })
            ]
          }
        )
      }
    )
  ] });
  return u ? /* @__PURE__ */ e(
    Wt,
    {
      theme: { algorithm: I === "dark" ? Y.darkAlgorithm : Y.defaultAlgorithm },
      children: B
    }
  ) : B;
}, li = Fn, { Footer: Pn } = ie, ct = {
  dev: { color: "geekblue", label: "DEV" },
  uat: { color: "gold", label: "UAT" },
  prod: { color: "success", label: "PROD" }
}, Bn = 7, si = ({
  orgName: t,
  env: n,
  version: r,
  commit: o,
  syncInfo: i,
  links: l,
  bordered: u = !0
}) => {
  const { token: a } = Y.useToken(), s = a.colorBgContainer, m = a.colorSplit ?? a.colorBorderSecondary, h = a.colorTextDescription ?? a.colorTextSecondary, g = `clamp(${a.paddingSM}px, 5vw, ${a.paddingLG}px)`, _ = i ? i.tooltip ? /* @__PURE__ */ e(vt, { title: i.tooltip, placement: "top", children: /* @__PURE__ */ e(F.Text, { style: { color: h }, children: i.label }) }) : /* @__PURE__ */ e(F.Text, { style: { color: h }, children: i.label }) : null, C = r ? /* @__PURE__ */ c(F.Text, { style: { color: h }, children: [
    "v",
    r
  ] }) : null, f = o ? /* @__PURE__ */ e(F.Text, { code: !0, style: { color: h }, children: o.slice(0, Bn) }) : null, S = l?.length ? /* @__PURE__ */ e(V, { size: a.marginSM, wrap: !0, children: l.map((b) => /* @__PURE__ */ e(F.Link, { href: b.href, style: { color: a.colorPrimary }, children: b.label }, b.href)) }) : null;
  return /* @__PURE__ */ e(
    Pn,
    {
      style: {
        background: s,
        borderTop: u ? `1px solid ${m}` : void 0,
        padding: `${a.paddingSM}px ${g}`
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          style: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: a.marginSM,
            minHeight: xe
          },
          children: [
            /* @__PURE__ */ c(V, { size: a.marginSM, wrap: !0, children: [
              /* @__PURE__ */ e(F.Text, { strong: !0, children: t ?? "DigiWedge Admin" }),
              _
            ] }),
            /* @__PURE__ */ c(V, { size: a.marginSM, wrap: !0, children: [
              n ? /* @__PURE__ */ e(he, { color: ct[n].color, children: ct[n].label }) : null,
              C,
              f,
              S
            ] })
          ]
        }
      )
    }
  );
}, { Footer: Rn } = ie, ci = ({
  primary: t,
  secondary: n,
  status: r,
  sticky: o = !0,
  safeArea: i = !0
}) => {
  const { token: l } = Y.useToken(), u = l.colorBgContainer, a = l.colorSplit ?? l.colorBorderSecondary, s = i ? `calc(${l.paddingSM}px + ${Nt})` : `${l.paddingSM}px`;
  return /* @__PURE__ */ e(
    Rn,
    {
      style: {
        background: u,
        borderTop: `1px solid ${a}`,
        padding: `${l.paddingSM}px clamp(${l.paddingSM}px, 6vw, ${l.paddingLG}px) ${s}`,
        position: o ? "sticky" : "static",
        bottom: o ? 0 : void 0,
        zIndex: o ? l.zIndexPopupBase : void 0
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: l.marginSM,
            minHeight: xe
          },
          children: [
            /* @__PURE__ */ e("div", { style: { minHeight: 24, flex: 1 }, children: r ? typeof r == "string" ? /* @__PURE__ */ e(F.Text, { type: "secondary", children: r }) : r : null }),
            /* @__PURE__ */ c(V, { size: l.marginSM, wrap: !0, children: [
              n?.map((m) => /* @__PURE__ */ e(E, { onClick: m.onClick, children: m.label }, m.label)),
              /* @__PURE__ */ e(
                E,
                {
                  type: "primary",
                  onClick: t.onClick,
                  disabled: t.disabled,
                  loading: t.loading,
                  children: t.label
                }
              )
            ] })
          ]
        }
      )
    }
  );
}, { Footer: $n } = ie, di = ({
  selectedCount: t = 0,
  bulkActions: n,
  pagination: r,
  extra: o,
  bordered: i = !0
}) => {
  const { token: l } = Y.useToken(), u = l.colorSplit ?? l.colorBorderSecondary, a = l.colorBgContainer, s = t > 0, [m, h] = L(!1), [g, _] = L(-1), C = Ae(null), f = Ae(null), S = Ae([]);
  oe(() => {
    !s && m && h(!1);
  }, [s, m]);
  const b = re(() => n?.length ? n.filter(
    (x) => !!(x?.key && x?.label && typeof x.onClick == "function")
  ) : [], [n]), I = b.length > 0, p = s && I, N = fe(() => {
    p && h((x) => !x);
  }, [p]);
  oe(() => {
    if (!m) {
      _(-1);
      return;
    }
    b.length > 0 && (_(0), S.current[0]?.focus());
    const x = (M) => {
      const y = M.target;
      y && (f.current?.contains(y) || C.current?.contains(y) || h(!1));
    }, P = (M) => {
      M.key === "Escape" && (h(!1), C.current?.focus());
    };
    return document.addEventListener("mousedown", x), document.addEventListener("keydown", P), () => {
      document.removeEventListener("mousedown", x), document.removeEventListener("keydown", P);
    };
  }, [m, b.length]);
  const q = fe((x) => {
    h(!1), x.onClick();
  }, []), H = fe(
    (x, P) => {
      const M = b.length;
      let y = P;
      switch (x.key) {
        case "ArrowDown":
          x.preventDefault(), y = (P + 1) % M;
          break;
        case "ArrowUp":
          x.preventDefault(), y = (P - 1 + M) % M;
          break;
        case "Home":
          x.preventDefault(), y = 0;
          break;
        case "End":
          x.preventDefault(), y = M - 1;
          break;
        case "Tab":
          h(!1);
          return;
        default:
          return;
      }
      _(y), S.current[y]?.focus();
    },
    [b.length]
  );
  return /* @__PURE__ */ e(
    $n,
    {
      style: {
        background: a,
        borderTop: i ? `1px solid ${u}` : void 0,
        padding: `${l.paddingSM}px clamp(${l.paddingSM}px, 5vw, ${l.paddingLG}px)`
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          style: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: l.marginSM,
            minHeight: xe
          },
          children: [
            /* @__PURE__ */ c(V, { size: l.marginSM, wrap: !0, children: [
              s ? /* @__PURE__ */ c(F.Text, { strong: !0, children: [
                t,
                " selected"
              ] }) : /* @__PURE__ */ e(F.Text, { type: "secondary", children: "No rows selected" }),
              I ? /* @__PURE__ */ c("div", { style: { position: "relative" }, children: [
                /* @__PURE__ */ e(
                  E,
                  {
                    ref: C,
                    disabled: !p,
                    onClick: N,
                    "aria-haspopup": "menu",
                    "aria-expanded": p ? m : void 0,
                    children: "Bulk actions"
                  }
                ),
                m ? /* @__PURE__ */ e(
                  "div",
                  {
                    ref: f,
                    role: "menu",
                    "aria-label": "Bulk actions",
                    style: {
                      position: "absolute",
                      top: l.paddingLG,
                      left: 0,
                      background: a,
                      border: `1px solid ${u}`,
                      borderRadius: l.borderRadiusLG,
                      boxShadow: l.boxShadowSecondary,
                      minWidth: 160,
                      zIndex: l.zIndexPopupBase,
                      display: "flex",
                      flexDirection: "column"
                    },
                    children: b.map((x, P) => /* @__PURE__ */ e(
                      "button",
                      {
                        ref: (M) => {
                          S.current[P] = M;
                        },
                        type: "button",
                        role: "menuitem",
                        tabIndex: g === P ? 0 : -1,
                        onClick: () => q(x),
                        onKeyDown: (M) => H(M, P),
                        style: {
                          width: "100%",
                          padding: `${l.paddingXS}px ${l.paddingSM}px`,
                          background: "transparent",
                          border: "none",
                          textAlign: "left",
                          cursor: "pointer"
                        },
                        children: x.label
                      },
                      x.key
                    ))
                  }
                ) : null
              ] }) : null
            ] }),
            /* @__PURE__ */ c(V, { size: l.marginSM, wrap: !0, children: [
              o,
              r
            ] })
          ]
        }
      )
    }
  );
}, { Footer: On } = ie, dt = (t) => t?.name ?? "—", ui = ({
  org: t,
  site: n,
  region: r,
  locale: o,
  impersonating: i,
  links: l
}) => {
  const { token: u } = Y.useToken();
  return /* @__PURE__ */ e(
    On,
    {
      style: {
        background: u.colorBgContainer,
        borderTop: `1px solid ${u.colorSplit ?? u.colorBorderSecondary}`,
        padding: `${u.paddingSM}px clamp(${u.paddingSM}px, 5vw, ${u.paddingXL}px)`
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: u.marginSM,
            minHeight: xe
          },
          children: [
            /* @__PURE__ */ c(V, { size: u.marginSM, wrap: !0, children: [
              /* @__PURE__ */ e(F.Text, { strong: !0, children: "Org:" }),
              /* @__PURE__ */ e(F.Text, { children: dt(t) }),
              /* @__PURE__ */ e(F.Text, { strong: !0, children: "Site:" }),
              /* @__PURE__ */ e(F.Text, { children: dt(n) }),
              r ? /* @__PURE__ */ e(he, { color: "blue", bordered: !1, children: r.toUpperCase() }) : null,
              o ? /* @__PURE__ */ e(he, { color: "purple", bordered: !1, children: o }) : null
            ] }),
            /* @__PURE__ */ c(V, { size: u.marginSM, wrap: !0, align: "center", children: [
              i ? /* @__PURE__ */ c(he, { color: "orange", bordered: !1, children: [
                "Impersonating ",
                i.name
              ] }) : null,
              l?.map((a) => /* @__PURE__ */ c(F.Link, { href: a.href, style: { color: u.colorPrimary }, children: [
                a.icon,
                a.icon ? /* @__PURE__ */ e("span", { style: { marginLeft: 4 }, children: a.label }) : a.label
              ] }, a.href))
            ] })
          ]
        }
      )
    }
  );
}, { Footer: zn } = ie, Wn = {
  ok: "success",
  warn: "warning",
  err: "error"
}, mi = ({ metrics: t, legal: n }) => {
  const { token: r } = Y.useToken();
  return /* @__PURE__ */ e(
    zn,
    {
      style: {
        background: r.colorBgContainer,
        borderTop: `1px solid ${r.colorSplit ?? r.colorBorderSecondary}`,
        padding: `${r.paddingSM}px clamp(${r.paddingSM}px, 6vw, ${r.paddingXL}px)`
      },
      children: /* @__PURE__ */ c(
        V,
        {
          orientation: "vertical",
          size: r.marginSM,
          style: { width: "100%", minHeight: xe },
          children: [
            /* @__PURE__ */ e(V, { size: r.marginSM, wrap: !0, children: t.map((o, i) => /* @__PURE__ */ c(
              he,
              {
                color: o.status ? Wn[o.status] : void 0,
                bordered: !1,
                style: { paddingInline: r.paddingXS, fontWeight: 500 },
                children: [
                  o.label,
                  ": ",
                  o.value
                ]
              },
              `${o.label}-${i}`
            )) }),
            n ? /* @__PURE__ */ e(F.Text, { type: "secondary", style: { fontSize: 12 }, children: n }) : null
          ]
        }
      )
    }
  );
}, { Footer: qn } = ie, hi = ({
  text: t = "© DigiWedge. All rights reserved.",
  links: n,
  align: r = "spread"
}) => {
  const { token: o } = Y.useToken(), i = r === "center" ? "center" : "space-between", l = `clamp(${o.paddingSM}px, 4vw, ${o.paddingLG}px)`, u = `${o.paddingXS}px`;
  return /* @__PURE__ */ e(
    qn,
    {
      style: {
        background: o.colorBgContainer,
        borderTop: `1px solid ${o.colorSplit ?? o.colorBorderSecondary}`,
        padding: `${u} ${l}`
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: i,
            alignItems: "center",
            flexWrap: "wrap",
            gap: o.marginSM,
            minHeight: xe,
            color: o.colorTextDescription ?? o.colorTextSecondary,
            fontSize: 12
          },
          children: [
            /* @__PURE__ */ e(F.Text, { type: "secondary", children: t }),
            n?.length ? /* @__PURE__ */ e(V, { size: o.marginSM, wrap: !0, children: n.map((a) => /* @__PURE__ */ e(F.Link, { href: a.href, style: { color: o.colorPrimary }, children: a.label }, a.href)) }) : null
          ]
        }
      )
    }
  );
}, { Header: Hn } = ie, pi = ({
  navItems: t,
  userMenuItems: n,
  notificationsCount: r = 0,
  user: o,
  selectedNavKey: i,
  borderColor: l,
  buttonColor: u,
  rightExtra: a,
  themeMode: s
}) => {
  const m = nt(), { token: h } = Y.useToken(), g = process.env.NODE_ENV === "test", _ = o?.avatarUrl ? "transparent" : "#4caf50", C = o?.name?.[0]?.toUpperCase() ?? "UNK", f = j.useMemo(() => t?.filter((w) => w?.key === "/") ?? [], [t]), S = j.useMemo(() => At(f), [f]), b = j.useMemo(() => {
    if (!n?.length)
      return { items: [], autoNavigateKeys: /* @__PURE__ */ new Set() };
    const w = [], U = /* @__PURE__ */ new Set();
    for (const B of n) {
      if (!B || typeof B != "object" || !("key" in B) || B.key == null || !("label" in B))
        continue;
      const R = B.label;
      if (R == null)
        continue;
      const ne = String(B.key), X = { ...B, key: ne, label: R };
      w.push(X), j.isValidElement(R) || U.add(ne);
    }
    return { items: w, autoNavigateKeys: U };
  }, [n]), I = b.items, p = b.autoNavigateKeys, N = I.length > 0, q = j.useRef(null), H = j.useRef(null), [x, P] = j.useState(!1), M = j.useCallback(() => {
    const w = q.current;
    w && typeof w.focus == "function" && w.focus();
  }, []), y = j.useCallback(
    (w) => {
      P(!1), w?.restoreFocus && requestAnimationFrame(() => {
        M();
      });
    },
    [M]
  ), D = j.useCallback(() => {
    N && P((w) => !w);
  }, [N]), A = j.useCallback(
    (w) => {
      N && (w.key === "Enter" || w.key === " ") && (w.preventDefault(), D());
    },
    [N, D]
  );
  return j.useEffect(() => {
    if (!x)
      return;
    const w = (U) => {
      const B = U.target;
      B && (H.current?.contains(B) || q.current?.contains(B) || y());
    };
    return document.addEventListener("mousedown", w), () => {
      document.removeEventListener("mousedown", w);
    };
  }, [y, x]), j.useEffect(() => {
    if (!x)
      return;
    const w = (U) => {
      U.key === "Escape" && (U.preventDefault(), y({ restoreFocus: !0 }));
    };
    return document.addEventListener("keydown", w), () => {
      document.removeEventListener("keydown", w);
    };
  }, [y, x]), /* @__PURE__ */ e(
    Hn,
    {
      style: {
        display: "flex",
        alignItems: "center",
        padding: 0,
        transition: "background 0.3s ease",
        borderBottom: `1px solid ${l || h.colorSplit || "#e0e0e0"}`,
        backgroundColor: h.colorBgContainer
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          style: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "0 16px"
          },
          children: [
            /* @__PURE__ */ e(
              Ge,
              {
                mode: "horizontal",
                items: f,
                selectedKeys: i ? [i] : [],
                onClick: ({ key: w }) => m(w),
                style: {
                  flex: 1,
                  minWidth: 0,
                  background: "transparent",
                  borderBottom: "none"
                }
              }
            ),
            g && S.length ? /* @__PURE__ */ e("ul", { style: Vn, "aria-hidden": !0, children: S.map((w) => /* @__PURE__ */ e("li", { children: w.label }, w.key)) }) : null,
            /* @__PURE__ */ c(V, { size: "middle", style: { marginLeft: "auto", display: "flex", alignItems: "center" }, children: [
              a,
              o?.name ? /* @__PURE__ */ c(be, { children: [
                !a && /* @__PURE__ */ e(
                  qt,
                  {
                    count: r,
                    "aria-label": `${r} notifications`,
                    style: { alignSelf: "center" },
                    children: /* @__PURE__ */ e(
                      E,
                      {
                        type: "text",
                        icon: /* @__PURE__ */ e(Jt, { style: { width: 18, height: 18 } }),
                        "aria-label": "Notifications",
                        style: {
                          color: h.colorText,
                          ...u ? { background: u, borderColor: u, color: "#fff" } : {}
                        }
                      }
                    )
                  }
                ),
                /* @__PURE__ */ c("div", { style: { position: "relative" }, children: [
                  /* @__PURE__ */ c(
                    V,
                    {
                      ref: q,
                      onClick: D,
                      onKeyDown: A,
                      role: "button",
                      tabIndex: N ? 0 : -1,
                      "aria-label": "User menu trigger",
                      "aria-haspopup": "menu",
                      "aria-expanded": N ? x : void 0,
                      style: { cursor: N ? "pointer" : "default", alignItems: "center" },
                      children: [
                        /* @__PURE__ */ e(
                          wt,
                          {
                            style: {
                              backgroundColor: _,
                              border: `2px solid ${h.colorPrimary}`
                            },
                            "aria-label": "User menu",
                            children: C
                          }
                        ),
                        /* @__PURE__ */ e(en, { style: { fontSize: 12, color: h.colorText } })
                      ]
                    }
                  ),
                  x ? /* @__PURE__ */ e(
                    "div",
                    {
                      ref: H,
                      role: "menu",
                      "aria-label": "User actions",
                      style: {
                        position: "absolute",
                        top: "calc(100% + 4px)",
                        right: 0,
                        background: h.colorBgElevated,
                        border: `1px solid ${h.colorBorder}`,
                        borderRadius: h.borderRadiusLG,
                        boxShadow: h.boxShadowSecondary,
                        minWidth: 180,
                        zIndex: h.zIndexPopupBase,
                        overflow: "hidden"
                      },
                      children: /* @__PURE__ */ e(
                        Ge,
                        {
                          items: I,
                          selectable: !1,
                          onClick: (w) => {
                            y();
                            const U = String(w.key);
                            p.has(U) && (w.domEvent.defaultPrevented || m(U));
                          },
                          style: {
                            borderInlineEnd: "none",
                            boxShadow: "none"
                          },
                          mode: "vertical"
                        }
                      )
                    }
                  ) : null
                ] })
              ] }) : /* @__PURE__ */ c(be, { children: [
                /* @__PURE__ */ e(
                  E,
                  {
                    type: "link",
                    onClick: () => m("/login"),
                    className: `header-login-button ${u ? "custom-color" : ""}`,
                    style: u ? { color: u } : { color: h.colorPrimary },
                    children: "Login"
                  }
                ),
                /* @__PURE__ */ e(
                  E,
                  {
                    type: "primary",
                    onClick: () => m("/signup"),
                    style: u ? { background: u, borderColor: u, color: "#fff" } : {
                      background: h.colorPrimary,
                      borderColor: h.colorPrimary,
                      color: "#fff"
                    },
                    children: "Sign Up"
                  }
                )
              ] })
            ] })
          ]
        }
      )
    }
  );
}, Vn = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0
};
function At(t) {
  if (!t?.length)
    return [];
  const n = [];
  for (const r of t) {
    if (!r || typeof r != "object")
      continue;
    const o = "key" in r && r.key != null ? String(r.key) : void 0, i = "label" in r ? r.label : void 0;
    typeof i == "string" && n.push({ key: o ?? i, label: i }), "children" in r && Array.isArray(r.children) && n.push(...At(r.children));
  }
  return n;
}
const rt = j.memo(
  ({
    themeMode: t = "light",
    size: n = "medium",
    // Defaults align visually with theme: light => light bg, dark => dark bg
    lightLogoSrc: r = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="48"><rect width="150" height="48" fill="%23ffffff"/><text x="75" y="30" font-size="14" text-anchor="middle" fill="%23000000">Light Logo</text></svg>',
    darkLogoSrc: o = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="48"><rect width="150" height="48" fill="%23000000"/><text x="75" y="30" font-size="14" text-anchor="middle" fill="%23ffffff">Dark Logo</text></svg>',
    style: i,
    alt: l
  }) => /* @__PURE__ */ e(
    "img",
    {
      src: t === "dark" ? o : r,
      alt: l ?? `${t === "dark" ? "Dark" : "Light"} Mode Logo`,
      style: {
        ...{
          small: { height: "24px", width: "auto" },
          medium: { height: "48px", width: "auto" },
          large: { height: "72px", width: "auto" }
        }[n],
        ...i
      }
    }
  )
), { useBreakpoint: jn } = Je, { Sider: Gn } = ie, { Text: Yn } = F, gi = ({
  collapsed: t,
  onCollapse: n,
  themeMode: r = "light",
  sidebarItems: o,
  onClick: i,
  selectedKeys: l,
  defaultSelectedKeys: u,
  defaultOpenKeys: a = [],
  logo: s,
  style: m,
  className: h,
  breakpoint: g = "md"
}) => {
  const { token: _ } = Y.useToken(), C = jn(), f = j.useRef(void 0), S = process.env.NODE_ENV === "test";
  j.useEffect(() => {
    const N = C[g];
    f.current !== void 0 && f.current !== N && n?.(!N), f.current = N;
  }, [C, g, n]);
  const b = j.useCallback(() => {
    n?.(!t);
  }, [t, n]), I = j.useMemo(
    () => ({
      theme: r,
      mode: "inline",
      items: o,
      onClick: i,
      selectedKeys: l,
      defaultSelectedKeys: u,
      defaultOpenKeys: a,
      style: { flex: 1, overflow: "auto" }
    }),
    [r, o, i, l, u, a]
  ), p = j.useMemo(() => Lt(o), [o]);
  return /* @__PURE__ */ c(
    Gn,
    {
      collapsible: !0,
      collapsed: t,
      theme: r,
      trigger: null,
      width: 240,
      collapsedWidth: 80,
      style: {
        height: "100%",
        maxHeight: "calc(100vh - 64px)",
        position: "sticky",
        top: 64,
        alignSelf: "flex-start",
        // Use token to dynamically adjust the background per theme
        background: _.colorBgContainer,
        paddingBottom: _.paddingLG,
        ...m
      },
      className: h,
      children: [
        /* @__PURE__ */ e(
          "div",
          {
            style: {
              padding: _.padding,
              borderBottom: `1px solid ${_.colorBorder}`
            },
            children: s || /* @__PURE__ */ e(Yn, { strong: !0, children: t ? "Logo" : "Application Name" })
          }
        ),
        /* @__PURE__ */ e(Ge, { ...I }),
        S && p.length ? /* @__PURE__ */ e("ul", { style: Kn, "aria-hidden": !0, children: p.map((N) => /* @__PURE__ */ e("li", { children: N.label }, N.key)) }) : null,
        /* @__PURE__ */ e(
          E,
          {
            type: "text",
            onClick: b,
            icon: t ? /* @__PURE__ */ e(tn, {}) : /* @__PURE__ */ e(nn, {}),
            style: {
              width: "100%",
              borderRadius: 0,
              borderTop: `1px solid ${_.colorBorder}`
            },
            "aria-label": t ? "Expand sidebar" : "Collapse sidebar"
          }
        )
      ]
    }
  );
}, Kn = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0
};
function Lt(t) {
  if (!t?.length)
    return [];
  const n = [];
  for (const r of t) {
    if (!r || typeof r != "object")
      continue;
    const o = "key" in r && r.key != null ? String(r.key) : void 0, i = "label" in r ? r.label : void 0;
    typeof i == "string" && n.push({ key: o ?? i, label: i }), "children" in r && Array.isArray(r.children) && n.push(...Lt(r.children));
  }
  return n;
}
const Qn = {
  DRAFT: "default",
  POSTED: "processing",
  PAID: "success",
  OVERDUE: "error",
  VOID: "warning",
  ISSUED: "default",
  SENT: "default",
  PART_PAID: "default",
  REFUNDED: "default"
}, We = ({ status: t }) => /* @__PURE__ */ e(he, { color: Qn[t], className: "px-2 text-xs font-medium", children: t }), fi = ({ label: t, color: n, closable: r = !1, onClose: o }) => /* @__PURE__ */ e(he, { color: n, closable: r, onClose: o, className: "px-2 text-xs font-medium", children: t }), { Text: Xn } = F, ot = (t, n = "ZAR", r = !0, o) => {
  const i = o ?? (typeof navigator < "u" ? navigator.language : "en-US"), l = Number(t), u = Math.abs(l), a = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }, m = new Intl.NumberFormat(i, {
    ...a,
    style: r ? "currency" : "decimal",
    currency: n,
    currencyDisplay: "narrowSymbol"
  }).format(u), h = r ? m : `${m} ${n}`;
  return `${l < 0 ? "−" : ""}${h}`;
}, ce = ({
  amount: t,
  currency: n = "ZAR",
  showSymbol: r = !0,
  className: o
}) => {
  const l = Number(t) < 0, u = ot(t, n, r);
  return /* @__PURE__ */ e(Xn, { className: o, type: l ? "danger" : void 0, strong: l, children: u });
};
ae.extend(mn);
const { RangePicker: Zn } = xt, Jn = () => {
  const t = ae(), n = t.startOf("week"), r = t.endOf("week"), o = t.startOf("month"), i = t.endOf("month"), l = t.month(), u = t.year(), a = l >= 6 ? ae(`${u}-07-01`) : ae(`${u - 1}-07-01`), s = a.add(1, "year").subtract(1, "day");
  return [
    { label: "📅 Today", value: [t, t] },
    {
      label: "📅 This Week",
      value: [n, r]
    },
    {
      label: "📅 This Month",
      value: [o, i]
    },
    { label: "📅 Financial Year", value: [a, s] }
  ];
}, Dt = ({
  value: t,
  onChange: n,
  presets: r = !0,
  allowClear: o = !1,
  disabled: i,
  className: l,
  open: u,
  "data-testid": a
}) => {
  const [s, m] = L([
    t?.[0] ?? null,
    t?.[1] ?? null
  ]);
  oe(() => {
    t && m(t);
  }, [t]);
  const h = (C, f) => {
    const b = ((I) => !!I && typeof I == "object" && "range" in I && I.range !== void 0)(f) ? f.range : void 0;
    return b === "start" && s[1] ? C.isAfter(s[1], "day") : b === "end" && s[0] ? C.isBefore(s[0], "day") : !1;
  };
  return /* @__PURE__ */ e(
    Zn,
    {
      value: t ?? s,
      onCalendarChange: (C) => {
        m(C);
      },
      onChange: (C) => {
        if (!C) {
          o && (m([null, null]), n?.([null, null]));
          return;
        }
        let [f, S] = C;
        f && S ? (f.isAfter(S) && ([f, S] = [S, f]), m([f, S]), n?.([f, S])) : o && (m([f ?? null, S ?? null]), n?.([f ?? null, S ?? null]));
      },
      presets: r ? Jn() : void 0,
      allowClear: o,
      disabled: i,
      className: l,
      disabledDate: h,
      open: u,
      "data-testid": a
    }
  );
}, er = ({
  x: t,
  y: n,
  width: r,
  height: o,
  payload: i,
  patternId: l,
  colorMap: u,
  onEdit: a,
  highlightColor: s,
  activeId: m,
  setActiveId: h,
  formatDate: g
}) => {
  if (!i || typeof t != "number" || typeof n != "number" || typeof r != "number" || typeof o != "number")
    return null;
  const _ = o * 0.6, C = n + (o - _) / 2, f = i.status === "OVERLAP" ? `url(#${l})` : u[i.status], S = /* @__PURE__ */ e(
    "rect",
    {
      x: t,
      y: C,
      width: r,
      height: _,
      fill: f,
      stroke: m === i.id ? s : void 0,
      strokeWidth: m === i.id ? 2 : 0,
      "data-testid": `bar-${i.id}`
    }
  );
  return a ? /* @__PURE__ */ e("foreignObject", { x: t, y: n, width: r, height: o, children: /* @__PURE__ */ e(
    "button",
    {
      style: {
        width: "100%",
        height: "100%",
        background: "transparent",
        border: "none",
        padding: 0,
        cursor: "pointer",
        position: "relative"
      },
      "aria-label": `${i.itemName} ${ot(i.price, i.currency)} ${g(new Date(i.from))} - ${g(new Date(i.to))} ${i.status}`,
      onClick: () => a(i.id),
      onMouseEnter: () => h(i.id),
      onMouseLeave: () => h(null),
      onFocus: () => h(i.id),
      onBlur: () => h(null),
      children: /* @__PURE__ */ e("svg", { width: "100%", height: "100%", style: { position: "absolute", top: 0, left: 0 }, children: S })
    }
  ) }) : S;
}, yi = ({
  schedules: t,
  onEdit: n,
  height: r = 60,
  className: o,
  showLegend: i = !1,
  groupBySeason: l = !1,
  locale: u,
  dateFormatter: a
}) => {
  const { token: s } = Y.useToken(), m = Rt(), [h, g] = L(null), _ = fe(
    (y) => a ? a(y) : y.toLocaleDateString(u),
    [a, u]
  ), { data: C, domain: f, domainStart: S } = re(() => {
    if (t.length === 0)
      return {
        data: [],
        domain: [0, 1],
        domainStart: 0
      };
    const y = [...t].sort(
      (Z, ke) => new Date(Z.from).getTime() - new Date(ke.from).getTime()
    ), D = y.map((Z) => new Date(Z.from).getTime()), A = y.map((Z) => new Date(Z.to).getTime()), w = Math.min(...D), U = Math.max(...A), R = (U - w || 1) * 0.05, ne = w - R, X = U + R;
    return {
      data: y.map((Z) => ({
        ...Z,
        offset: new Date(Z.from).getTime() - ne,
        duration: new Date(Z.to).getTime() - new Date(Z.from).getTime()
      })),
      domain: [0, X - ne],
      domainStart: ne
    };
  }, [t]), b = S + f[1], I = re(() => {
    const y = (b - S) / 4;
    return Array.from({ length: 5 }, (D, A) => A * y);
  }, [b, S]), p = Date.now() - S, N = p >= 0 && p <= f[1], q = re(
    () => ({
      ACTIVE: s.colorSuccess,
      FUTURE: s.colorInfo,
      EXPIRED: s.colorTextDisabled,
      OVERLAP: s.colorError
    }),
    [s]
  ), H = re(() => {
    if (!l)
      return [];
    const y = /* @__PURE__ */ new Map();
    return C.forEach((D) => {
      const A = new Date(D.from).getFullYear().toString(), w = D.offset, U = D.offset + D.duration, B = y.get(A);
      B ? (B.start = Math.min(B.start, w), B.end = Math.max(B.end, U)) : y.set(A, { start: w, end: U });
    }), Array.from(y.entries()).map(([D, A]) => ({
      season: D,
      start: A.start,
      end: A.end
    }));
  }, [l, C]), x = fe(
    (y) => /* @__PURE__ */ e(
      er,
      {
        ...y,
        patternId: m,
        colorMap: q,
        onEdit: n,
        highlightColor: s.colorPrimaryHover,
        activeId: h,
        setActiveId: g,
        formatDate: _
      }
    ),
    [m, q, n, h, g, s.colorPrimaryHover, _]
  );
  if (t.length === 0)
    return /* @__PURE__ */ e(Ht, { className: o });
  const P = t.some((y) => y.status === "OVERLAP"), M = ({ active: y, payload: D }) => {
    if (y && D?.length) {
      const A = D[0].payload, w = new Date(A.from).getFullYear().toString();
      return /* @__PURE__ */ c("div", { style: { padding: 8 }, children: [
        l && /* @__PURE__ */ c("div", { style: { fontStyle: "italic" }, children: [
          "Season ",
          w
        ] }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("strong", { children: A.itemName }) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(ce, { amount: A.price, currency: A.currency }) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ c("span", { children: [
          _(new Date(A.from)),
          " - ",
          _(new Date(A.to))
        ] }) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(We, { status: ut(A.status) }) })
      ] });
    }
    return null;
  };
  return /* @__PURE__ */ c("div", { className: o, style: { width: "100%", height: r }, children: [
    P && /* @__PURE__ */ e(We, { status: ut("OVERLAP") }),
    /* @__PURE__ */ e(hn, { width: "100%", height: "100%", children: /* @__PURE__ */ c(pn, { data: C, margin: { top: 0, right: 0, left: 0, bottom: 0 }, barCategoryGap: 0, children: [
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ c(
        "pattern",
        {
          id: m,
          patternUnits: "userSpaceOnUse",
          width: 8,
          height: 8,
          patternTransform: "rotate(45)",
          children: [
            /* @__PURE__ */ e("rect", { x: "0", y: "0", width: "8", height: "8", fill: s.colorErrorBg }),
            /* @__PURE__ */ e("line", { x1: "0", y1: "0", x2: "0", y2: "8", stroke: s.colorError, strokeWidth: "2" })
          ]
        }
      ) }),
      /* @__PURE__ */ e(
        gn,
        {
          dataKey: "offset",
          type: "number",
          domain: f,
          ticks: I,
          tickFormatter: (y) => _(new Date(S + y)),
          tick: { fontSize: 10 }
        }
      ),
      /* @__PURE__ */ e(fn, { hide: !0 }),
      /* @__PURE__ */ e(yn, { content: M }),
      l && H.map((y) => /* @__PURE__ */ e(
        st,
        {
          x: (y.start + y.end) / 2,
          stroke: "none",
          label: { position: "top", value: y.season, fontSize: 10 }
        },
        y.season
      )),
      N && /* @__PURE__ */ e(
        st,
        {
          x: p,
          stroke: s.colorWarning,
          strokeDasharray: "3 3",
          label: { position: "top", value: "Today", fontSize: 10 }
        }
      ),
      /* @__PURE__ */ e(
        bn,
        {
          dataKey: "duration",
          minPointSize: 2,
          isAnimationActive: !1,
          shape: x
        }
      )
    ] }) }),
    i && /* @__PURE__ */ e(
      "section",
      {
        className: "mt-1 flex flex-wrap gap-2 text-xs",
        "data-testid": "legend",
        "aria-label": "Chart legend",
        children: Object.entries(q).map(
          ([y, D]) => /* @__PURE__ */ c("div", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: "inline-block w-3 h-3 rounded-sm border",
                style: { backgroundColor: D, borderColor: D },
                "data-testid": `legend-swatch-${y}`
              }
            ),
            /* @__PURE__ */ e("span", { children: y })
          ] }, y)
        )
      }
    )
  ] });
};
function ut(t) {
  switch (t) {
    case "ACTIVE":
      return "ISSUED";
    case "FUTURE":
      return "DRAFT";
    case "EXPIRED":
      return "VOID";
    case "OVERLAP":
      return "OVERDUE";
    default:
      return "DRAFT";
  }
}
const It = (t) => /* @__PURE__ */ e(Vt, { destroyOnClose: !0, ...t }), bi = ({
  open: t,
  items: n,
  existing: r,
  onCreate: o,
  onClose: i,
  drawerWidth: l = 500
}) => {
  const { message: u } = Se.useApp(), [a, s] = L(0), [m, h] = L(), [g, _] = L(null), [C, f] = L(0), [S, b] = L("ZAR"), [I, p] = L(!1);
  oe(() => {
    t || (s(0), h(void 0), _(null), f(0), b("ZAR"), p(!1));
  }, [t]);
  const N = n.find((A) => A.id === m), q = g ? g[0].isAfter(g[1]) : !1, x = (() => {
    if (!g || !N) return !1;
    const [A, w] = g;
    return r.filter((U) => U.itemName === N.name).some((U) => {
      const B = ae(U.from), R = ae(U.to);
      return !B.isAfter(w) && !R.isBefore(A);
    });
  })(), P = !!m, M = !!g && !q && !x, y = async () => {
    if (!(!N || !g)) {
      p(!0);
      try {
        const [A, w] = g, U = {
          itemName: N.name,
          from: A.toISOString(),
          to: w.toISOString(),
          price: C,
          currency: S,
          id: "",
          status: "FUTURE"
        };
        await Promise.resolve(o(U)), i();
      } catch (A) {
        u.error(d("en-US", "createError")), console.error(A);
      } finally {
        p(!1);
      }
    }
  }, D = [
    /* @__PURE__ */ e(tr, { items: n, itemId: m, onChange: h }, "step1"),
    /* @__PURE__ */ e(
      nr,
      {
        dates: g,
        onChange: (A) => _(A),
        rangeInvalid: q,
        overlap: x
      },
      "step2"
    ),
    /* @__PURE__ */ e(
      rr,
      {
        item: N?.name ?? "",
        dates: g,
        price: C,
        currency: S,
        onPriceChange: f,
        onCurrencyChange: b
      },
      "step3"
    ),
    /* @__PURE__ */ e(
      or,
      {
        item: N?.name ?? "",
        dates: g,
        price: C,
        currency: S
      },
      "review"
    )
  ];
  return /* @__PURE__ */ c(It, { open: t, onClose: i, size: l, children: [
    /* @__PURE__ */ e(
      et,
      {
        current: a,
        style: { marginBottom: 24 },
        items: [
          { title: d("en-US", "itemLabel") },
          { title: d("en-US", "dateRangeLabel") },
          { title: d("en-US", "priceLabel") },
          { title: d("en-US", "reviewLabel") }
        ]
      }
    ),
    D[a],
    /* @__PURE__ */ c(V, { style: { marginTop: 24 }, children: [
      a > 0 && /* @__PURE__ */ e(E, { onClick: () => s(a - 1), children: d("en-US", "backAction") }),
      /* @__PURE__ */ c(V, { style: { marginLeft: "auto" }, children: [
        a < 3 && /* @__PURE__ */ e(
          E,
          {
            type: "primary",
            onClick: () => s(a + 1),
            disabled: a === 0 ? !P : a === 1 ? !M : !1,
            children: d("en-US", "nextAction")
          }
        ),
        a === 3 && /* @__PURE__ */ e(
          E,
          {
            type: "primary",
            onClick: y,
            "data-testid": "create-btn",
            loading: I,
            children: d("en-US", "createAction")
          }
        ),
        /* @__PURE__ */ e(E, { onClick: i, children: d("en-US", "cancelAction") })
      ] })
    ] })
  ] });
}, tr = ({ items: t, itemId: n, onChange: r }) => /* @__PURE__ */ e(v, { layout: "vertical", children: /* @__PURE__ */ e(v.Item, { label: d("en-US", "itemLabel"), required: !0, children: /* @__PURE__ */ e(
  Ie,
  {
    showSearch: !0,
    placeholder: d("en-US", "selectItem"),
    optionFilterProp: "label",
    style: { width: "100%" },
    value: n,
    onChange: r,
    options: t.map((o) => ({ value: o.id, label: o.name }))
  }
) }) }), nr = ({ dates: t, onChange: n, rangeInvalid: r, overlap: o }) => {
  const i = ae();
  return /* @__PURE__ */ e(v, { layout: "vertical", children: /* @__PURE__ */ e(
    v.Item,
    {
      label: d("en-US", "dateRangeLabel"),
      validateStatus: r || o ? "error" : "",
      help: r ? d("en-US", "startBeforeEnd") : o ? d("en-US", "scheduleOverlap") : void 0,
      children: /* @__PURE__ */ c(V, { orientation: "vertical", style: { width: "100%" }, size: "middle", children: [
        /* @__PURE__ */ e(V, { size: "small", children: /* @__PURE__ */ c(E, { type: "link", onClick: () => n([i, i]), children: [
          /* @__PURE__ */ e("span", { role: "img", "aria-label": "calendar", children: "📅" }),
          " ",
          d("en-US", "today")
        ] }) }),
        /* @__PURE__ */ e(Dt, { value: t ?? void 0, onChange: n })
      ] })
    }
  ) });
}, rr = ({
  item: t,
  dates: n,
  price: r,
  currency: o,
  onPriceChange: i,
  onCurrencyChange: l
}) => /* @__PURE__ */ c(v, { layout: "vertical", children: [
  /* @__PURE__ */ c(F.Text, { children: [
    t,
    " — ",
    n ? `${n[0].format("YYYY-MM-DD")} - ${n[1].format("YYYY-MM-DD")}` : ""
  ] }),
  /* @__PURE__ */ e(v.Item, { label: d("en-US", "priceLabel"), children: /* @__PURE__ */ e(
    tt,
    {
      value: r,
      onChange: (u) => i(u != null ? Number(u) : 0),
      min: 0,
      style: { width: "100%" }
    }
  ) }),
  /* @__PURE__ */ e(v.Item, { label: d("en-US", "currencyLabel"), children: /* @__PURE__ */ e(
    Ie,
    {
      value: o,
      onChange: l,
      options: [
        { value: "ZAR", label: "ZAR" },
        { value: "USD", label: "USD" },
        { value: "EUR", label: "EUR" }
      ]
    }
  ) }),
  /* @__PURE__ */ e(ce, { amount: r, currency: o })
] }), or = ({ item: t, dates: n, price: r, currency: o }) => /* @__PURE__ */ c(V, { orientation: "vertical", style: { width: "100%" }, size: "middle", children: [
  /* @__PURE__ */ e(F.Text, { strong: !0, children: t }),
  /* @__PURE__ */ e(F.Text, { children: n ? `${n[0].format("YYYY-MM-DD")} - ${n[1].format("YYYY-MM-DD")}` : "" }),
  /* @__PURE__ */ e(ce, { amount: r, currency: o })
] }), ir = "startBeforeEnd", ar = "scheduleOverlap", mt = (t, n, r) => n && t.isAfter(n) ? ir : r(t, n) ? ar : null, lr = [
  { label: "ZAR", value: "ZAR" },
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" }
], sr = Sn.string().length(3, "Invalid currency code").regex(/^[A-Za-z]{3}$/, "Invalid currency code").transform((t) => t.toUpperCase()), Si = ({
  visible: t,
  schedule: n,
  otherSchedules: r,
  onSave: o,
  onCancel: i,
  onDelete: l
}) => {
  const [u] = v.useForm(), [a, s] = L(null);
  oe(() => {
    t && u.setFieldsValue({
      itemName: n.itemName,
      range: [ae(n.from), n.to ? ae(n.to) : null],
      price: n.price,
      currency: n.currency ?? "ZAR"
    });
  }, [t, n, u]);
  const m = (f, S) => r?.length ? r.some((b) => {
    if (b.id === n.id) return !1;
    const I = ae(b.from), p = b.to ? ae(b.to) : null, N = !p || f.isBefore(p) || f.isSame(p), q = !S || I.isBefore(S) || I.isSame(S);
    return N && q;
  }) : !1, h = () => {
    const [f, S] = u.getFieldValue("range");
    if (!f || S === void 0) {
      s(null);
      return;
    }
    s(mt(f, S, m));
  }, g = async () => {
    try {
      const f = await u.validateFields(), [S, b] = f.range, I = mt(S, b, m);
      if (I) {
        s(I);
        return;
      }
      const p = sr.safeParse(f.currency);
      if (!p.success) {
        u.setFields([{ name: "currency", errors: [p.error.issues[0].message] }]);
        return;
      }
      o({
        ...n,
        itemName: f.itemName,
        from: S.toISOString(),
        to: b ? b.toISOString() : "",
        price: f.price,
        currency: p.data
      }), u.resetFields(), s(null);
    } catch {
    }
  }, _ = () => {
    u.resetFields(), s(null), i();
  }, C = () => {
    l && (l(n.id), u.resetFields(), s(null));
  };
  return /* @__PURE__ */ e(
    Me,
    {
      title: d("en-US", "editPriceScheduleTitle"),
      open: t,
      onOk: g,
      onCancel: _,
      okText: d("en-US", "saveAction"),
      cancelText: d("en-US", "cancelAction"),
      footer: (f, { OkBtn: S, CancelBtn: b }) => /* @__PURE__ */ c(V, { style: { display: "flex", justifyContent: "space-between", width: "100%" }, children: [
        l ? /* @__PURE__ */ e(
          jt,
          {
            title: d("en-US", "deleteConfirmTitle"),
            description: d("en-US", "deleteScheduleConfirmMessage"),
            onConfirm: C,
            okText: d("en-US", "deleteAction"),
            cancelText: d("en-US", "cancelAction"),
            okButtonProps: { danger: !0 },
            children: /* @__PURE__ */ e(E, { danger: !0, icon: /* @__PURE__ */ e(kt, {}), "data-testid": "delete-btn", children: d("en-US", "deleteAction") })
          }
        ) : /* @__PURE__ */ e("div", {}),
        /* @__PURE__ */ c(V, { children: [
          /* @__PURE__ */ e(b, {}),
          /* @__PURE__ */ e(S, {})
        ] })
      ] }),
      children: /* @__PURE__ */ c(v, { form: u, layout: "vertical", onFieldsChange: h, children: [
        /* @__PURE__ */ e(
          v.Item,
          {
            name: "itemName",
            label: d("en-US", "itemLabel"),
            rules: [{ required: !0 }],
            children: /* @__PURE__ */ e(W, { "data-testid": "itemName" })
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            name: "range",
            label: d("en-US", "dateRangeLabel"),
            rules: [{ required: !0 }],
            validateStatus: a ? "error" : void 0,
            help: a ? d("en-US", a) : void 0,
            children: /* @__PURE__ */ e(Dt, { "data-testid": "range" })
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            name: "price",
            label: d("en-US", "priceLabel"),
            rules: [{ required: !0, type: "number", min: 0 }],
            children: /* @__PURE__ */ e(tt, { "data-testid": "price", style: { width: "100%" } })
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            name: "currency",
            label: d("en-US", "currencyLabel"),
            rules: [{ required: !0 }],
            children: /* @__PURE__ */ e(Ie, { options: lr, "data-testid": "currency" })
          }
        )
      ] })
    }
  );
}, Ke = (t, n = 1) => t.map((r, o, i) => ({
  key: r.id,
  title: r.title,
  children: r.children ? Ke(r.children, n + 1) : void 0,
  ariaLevel: n,
  ariaPosinset: o + 1,
  ariaSetsize: i.length
})), ve = (t) => t.map((n) => ({
  id: String(n.key),
  title: typeof n.title == "string" ? n.title : "",
  children: n.children ? ve(n.children) : void 0
})), Re = (t) => t.map((n) => ({
  ...n,
  children: n.children ? Re(n.children) : void 0
})), Mt = (t, n, r) => t.map((o) => {
  if (o.key === n)
    return { ...o, title: r };
  if (o.children) {
    const i = Mt(o.children, n, r);
    if (i !== o.children)
      return { ...o, children: i };
  }
  return o;
}), Ut = (t) => !t.children || t.children.length === 0 ? 1 : 1 + Math.max(...t.children.map(Ut)), Be = (t) => t.length === 0 ? 0 : Math.max(...t.map(Ut)), vi = (t) => {
  const n = [], r = (o) => {
    o.forEach((i) => {
      n.push({ id: i.id, title: i.title }), i.children && r(i.children);
    });
  };
  return r(t), n;
}, Et = (t, n) => {
  if (!n) return t;
  const r = n.toLowerCase();
  return t.map((o) => {
    const i = o.children ? Et(o.children, n) : [];
    return String(o.title).toLowerCase().includes(r) || i.length ? { ...o, children: i } : null;
  }).filter(Boolean);
}, we = (t, n, r = null) => {
  for (let o = 0; o < t.length; o++) {
    const i = t[o];
    if (i.key === n)
      return { parent: t, index: o, parentNode: r };
    const l = i.children;
    if (l) {
      const u = we(l, n, i);
      if (u) return u;
    }
  }
  return null;
}, Qe = (t, n, r) => {
  for (let o = 0; o < t.length; o++) {
    const i = t[o];
    if (i.key === n)
      return r?.(i, o, t), i;
    if (i.children) {
      const l = Qe(i.children, n, r);
      if (l) return l;
    }
  }
  return null;
}, Xe = (t, n) => {
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    if (o.key === n)
      return t.splice(r, 1)[0];
    const i = o.children;
    if (i) {
      const l = Xe(i, n);
      if (l) return l;
    }
  }
  return null;
}, ht = (t, n) => {
  const r = we(t, n);
  if (!r || r.index === 0) return !1;
  const { parent: o, index: i } = r;
  return [o[i - 1], o[i]] = [o[i], o[i - 1]], !0;
}, pt = (t, n) => {
  const r = we(t, n);
  if (!r || r.index === r.parent.length - 1) return !1;
  const { parent: o, index: i } = r;
  return [o[i], o[i + 1]] = [o[i + 1], o[i]], !0;
}, gt = (t, n) => {
  const r = we(t, n);
  if (!r || r.index === 0) return !1;
  const { parent: o, index: i } = r, l = o[i - 1], u = o.splice(i, 1)[0];
  return l.children = l.children || [], l.children.push(u), !0;
}, ft = (t, n) => {
  const r = we(t, n);
  if (!r || !r.parentNode) return !1;
  const { parent: o, index: i, parentNode: l } = r, u = we(t, l.key);
  if (!u) return !1;
  const a = o.splice(i, 1)[0];
  return u.parent.splice(u.index + 1, 0, a), !0;
}, cr = () => typeof globalThis.crypto?.randomUUID == "function" ? globalThis.crypto.randomUUID() : Math.random().toString(36).slice(2), dr = -1e4, ur = -1e4, wi = (t) => {
  const {
    data: n,
    onChange: r,
    className: o,
    maxDepth: i,
    depthErrorMessage: l
  } = t, u = i ?? 4, a = l ?? `Max depth exceeded (limit: ${u})`, { __testOpenMenuForKey: s, __testRenderMenu: m, __testOnFilteredTree: h } = t, [g, _] = L(() => Ke(n)), [C, f] = L(""), [S, b] = L(!1), [I, p] = L(null), [N, q] = L(null), [H, x] = L(null), [P, M] = L(""), [y, D] = L(null), { token: A } = Y.useToken(), w = Ae(null), U = Ae(null), B = re(() => {
    const k = [], $ = (G) => {
      G.forEach((de) => {
        k.push(de.key), de.children && $(de.children);
      });
    };
    return $(g), k;
  }, [g]), R = re(() => Et(g, C), [g, C]);
  oe(() => {
    h?.(R);
  }, [h, R]), oe(() => (_(Ke(n)), () => {
    w.current && clearTimeout(w.current);
  }), [n]), oe(() => {
    if (!(typeof s > "u")) {
      if (s) {
        D({ x: 0, y: 0, key: s });
        return;
      }
      D(null);
    }
  }, [s]);
  const ne = fe(() => {
    b(!0), w.current = setTimeout(() => b(!1), 3e3);
  }, []), X = fe(
    (k) => {
      if (!N) return;
      const $ = Re(g);
      if (k($, N)) {
        if (Be(ve($)) > u) {
          ne();
          return;
        }
        _($), r(ve($));
      }
    },
    [N, g, u, r, ne]
  ), Ue = fe(
    (k) => {
      if (!(!k.ctrlKey || !N))
        switch (k.key) {
          case "ArrowUp":
            X(ht);
            break;
          case "ArrowDown":
            X(pt);
            break;
          case "ArrowRight":
            X(gt);
            break;
          case "ArrowLeft":
            X(ft);
            break;
        }
    },
    [N, X]
  ), Z = fe(
    (k, $) => {
      const G = Mt(g, k, $.trim() || "Untitled");
      x(null), _(G), r(ve(G));
    },
    [g, r]
  ), ke = (k) => {
    const { node: $ } = k;
    U.current = $;
  }, se = () => {
    U.current = null;
  }, Ee = (k) => {
    const { node: $ } = k, G = U.current ? Be(ve([U.current])) : 1, ee = String($.pos).split("-").length - 1 + G;
    p(ee > u ? String($.key) : null);
  }, Fe = (k) => {
    const $ = k.node.key, G = k.dragNode.key, de = k.node.pos.split("-"), ee = k.dropPosition - Number(de.at(-1)), pe = Re(g), ye = Xe(pe, G);
    if (!ye) return;
    if (k.dropToGap) {
      const ge = we(pe, $);
      if (!ge) return;
      const { parent: Ve, index: Pe } = ge;
      Ve.splice(ee === -1 ? Pe : Pe + 1, 0, ye);
    } else {
      const ge = Qe(pe, $);
      if (!ge) return;
      ge.children ??= [], ge.children.unshift(ye);
    }
    const Ce = ve(pe);
    if (Be(Ce) > u) {
      ne(), p($);
      return;
    }
    p(null), _(pe), r(Ce);
  }, qe = (k) => {
    k.event.preventDefault(), D({
      x: k.event.pageX,
      y: k.event.pageY,
      key: String(k.node.key)
    });
  }, J = ({ key: k }) => {
    if (!y) return;
    const $ = y.key, G = Re(g);
    if (k === "add") {
      const ee = Qe(G, $);
      if (!ee) return;
      const pe = {
        key: cr(),
        title: "New node",
        ariaLevel: ee.ariaLevel + 1,
        ariaPosinset: (ee.children?.length ?? 0) + 1,
        ariaSetsize: (ee.children?.length ?? 0) + 1
      };
      ee.children = [...ee.children ?? [], pe], ee.children.forEach((ye, Ce) => {
        ye.ariaPosinset = Ce + 1, ye.ariaSetsize = ee.children ? ee.children.length : 0;
      });
    } else k === "delete" && Xe(G, $);
    const de = ve(G);
    if (Be(de) > u) {
      ne(), p($), D(null);
      return;
    }
    p(null), _(G), r(de), D(null);
  };
  oe(() => {
    if (!y)
      return;
    const k = () => D(null);
    return document.addEventListener("mousedown", k), () => {
      document.removeEventListener("mousedown", k);
    };
  }, [y]);
  const He = re(() => {
    const k = ($) => $.map((G) => ({
      ...G,
      className: G.key === I ? "text-red-500" : void 0,
      children: G.children ? k(G.children) : void 0
    }));
    return k(R);
  }, [R, I]);
  return /* @__PURE__ */ c(be, { children: [
    /* @__PURE__ */ e(
      W,
      {
        placeholder: "Filter…",
        allowClear: !0,
        prefix: /* @__PURE__ */ e(rn, {}),
        style: { marginBottom: 8 },
        value: C,
        onChange: (k) => f(k.target.value)
      }
    ),
    S && /* @__PURE__ */ e(
      $e,
      {
        type: "error",
        message: a,
        closable: !0,
        showIcon: !0,
        style: { marginBottom: 8 }
      }
    ),
    /* @__PURE__ */ e(
      Gt,
      {
        className: o,
        blockNode: !0,
        draggable: !0,
        expandedKeys: B,
        autoExpandParent: !0,
        treeData: He,
        onSelect: (k) => q(String(k[0])),
        onKeyDown: Ue,
        onDragStart: ke,
        onDragEnd: se,
        onDragOver: Ee,
        onDrop: Fe,
        onRightClick: qe,
        titleRender: (k) => H === k.key ? /* @__PURE__ */ e(
          W,
          {
            size: "small",
            autoFocus: !0,
            value: P,
            onChange: ($) => M($.target.value),
            onBlur: () => Z(String(k.key), P),
            onPressEnter: () => Z(String(k.key), P),
            onKeyDown: ($) => $.stopPropagation()
          }
        ) : /* @__PURE__ */ e(
          "span",
          {
            onDoubleClick: () => {
              x(String(k.key)), M(String(k.title));
            },
            className: String(k.className || ""),
            children: String(k.title)
          }
        )
      }
    ),
    /* @__PURE__ */ c("div", { style: { marginTop: 8 }, children: [
      /* @__PURE__ */ e(
        E,
        {
          "aria-label": "Move up",
          size: "small",
          disabled: !N,
          onClick: () => X(ht),
          children: "↑"
        }
      ),
      /* @__PURE__ */ e(
        E,
        {
          "aria-label": "Move down",
          size: "small",
          disabled: !N,
          onClick: () => X(pt),
          style: { marginLeft: 4 },
          children: "↓"
        }
      ),
      /* @__PURE__ */ e(
        E,
        {
          "aria-label": "Indent",
          size: "small",
          disabled: !N,
          onClick: () => X(gt),
          style: { marginLeft: 4 },
          children: "↪"
        }
      ),
      /* @__PURE__ */ e(
        E,
        {
          "aria-label": "Outdent",
          size: "small",
          disabled: !N,
          onClick: () => X(ft),
          style: { marginLeft: 4 },
          children: "↩"
        }
      )
    ] }),
    y && /* @__PURE__ */ c(
      "div",
      {
        role: "menu",
        "aria-label": "Node actions",
        onMouseDown: (k) => k.stopPropagation(),
        style: {
          position: "absolute",
          left: y.x,
          top: y.y,
          background: A.colorBgElevated,
          border: `1px solid ${A.colorBorder}`,
          borderRadius: A.borderRadiusLG,
          boxShadow: A.boxShadowSecondary,
          display: "flex",
          flexDirection: "column",
          minWidth: 160,
          zIndex: A.zIndexPopupBase
        },
        children: [
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              role: "menuitem",
              onClick: () => J({ key: "add" }),
              style: {
                padding: `${A.paddingXS}px ${A.paddingSM}px`,
                textAlign: "left",
                background: "transparent",
                border: "none",
                cursor: "pointer"
              },
              children: "Add child"
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              role: "menuitem",
              onClick: () => J({ key: "delete" }),
              style: {
                padding: `${A.paddingXS}px ${A.paddingSM}px`,
                textAlign: "left",
                background: "transparent",
                border: "none",
                cursor: "pointer"
              },
              children: "Delete"
            }
          )
        ]
      }
    ),
    m && y && /* @__PURE__ */ c(
      "div",
      {
        "data-testid": "classification-tree__test-menu",
        style: {
          position: "absolute",
          left: dr,
          top: ur
        },
        children: [
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: () => J({ key: "add" }),
              children: "Add child"
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: () => J({ key: "delete" }),
              children: "Delete"
            }
          )
        ]
      }
    )
  ] });
}, xi = ({
  currency: t = "ZAR",
  style: n,
  onChange: r,
  ...o
}) => /* @__PURE__ */ e(
  tt,
  {
    step: 0.01,
    style: { width: "100%", ...n },
    formatter: (i) => i == null ? "" : `${ot(i, t, !1)} ${t}`,
    parser: (i) => Number(String(i).replace(/[A-Za-z\s,]+/g, "")),
    onChange: (i) => r?.(typeof i == "number" ? i : null),
    ...o
  }
), ki = ({
  balance: t = null,
  adjustments: n = []
}) => {
  const [r, o] = L(t), [i, l] = L(n ?? []), u = re(
    () => (i ?? []).filter((s) => s.amount > 0),
    [i]
  ), a = re(
    () => (i ?? []).filter((s) => s.amount < 0),
    [i]
  );
  return oe(() => {
    if (t !== null || n && n.length > 0) {
      o(t), l(n ?? []);
      return;
    }
    (async () => {
      try {
        const m = await fetch("/api/stripe/balance");
        if (!m.ok)
          throw new Error("Failed to fetch balance");
        const h = await m.json();
        o(h.balance), l(Array.isArray(h.adjustments) ? h.adjustments : []);
      } catch (m) {
        console.error(m);
      }
    })();
  }, [t, n]), /* @__PURE__ */ c(Te, { title: "Current Balance", bordered: !1, "data-testid": "balance-card", children: [
    /* @__PURE__ */ e("div", { "data-testid": "current-balance", children: r !== null ? (r / 100).toFixed(2) : "Loading..." }),
    /* @__PURE__ */ c("div", { style: { marginTop: 12 }, children: [
      /* @__PURE__ */ e("div", { children: "Credits" }),
      u.length === 0 ? /* @__PURE__ */ e("div", { children: "None" }) : /* @__PURE__ */ e("div", { role: "list", style: { display: "flex", flexDirection: "column", gap: 6 }, children: u.map((s) => /* @__PURE__ */ c(
        "div",
        {
          role: "listitem",
          "data-testid": "adjustment-item",
          style: {
            display: "flex",
            justifyContent: "space-between",
            padding: "6px 0",
            borderBottom: "1px solid #f0f0f0"
          },
          children: [
            /* @__PURE__ */ e("div", { children: s.description ?? s.type }),
            /* @__PURE__ */ e("span", { children: (s.amount / 100).toFixed(2) })
          ]
        },
        s.id
      )) })
    ] }),
    /* @__PURE__ */ c("div", { style: { marginTop: 12 }, children: [
      /* @__PURE__ */ e("div", { children: "Debits" }),
      a.length === 0 ? /* @__PURE__ */ e("div", { children: "None" }) : /* @__PURE__ */ e("div", { role: "list", style: { display: "flex", flexDirection: "column", gap: 6 }, children: a.map((s) => /* @__PURE__ */ c(
        "div",
        {
          role: "listitem",
          "data-testid": "adjustment-item",
          style: {
            display: "flex",
            justifyContent: "space-between",
            padding: "6px 0",
            borderBottom: "1px solid #f0f0f0"
          },
          children: [
            /* @__PURE__ */ e("div", { children: s.description ?? s.type }),
            /* @__PURE__ */ e("span", { children: (s.amount / 100).toFixed(2) })
          ]
        },
        s.id
      )) })
    ] })
  ] });
}, Ci = ({ invoices: t, groupBySeason: n = !1 }) => {
  const [r, o] = L("ALL"), i = r === "ALL" ? t : t.filter((s) => s.status === r), l = re(() => n ? i.reduce(
    (s, m) => {
      const h = m.period.match(/(\d{4})/), g = h ? h[1] : "Unknown";
      return s[g] || (s[g] = []), s[g].push(m), s;
    },
    {}
  ) : { All: i }, [i, n]), u = [
    {
      title: "Invoice #",
      dataIndex: "id",
      sorter: (s, m) => s.id.localeCompare(m.id)
    },
    {
      title: "Period",
      dataIndex: "period",
      sorter: (s, m) => s.period.localeCompare(m.period)
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (s, m) => s.amount - m.amount,
      render: (s, m) => /* @__PURE__ */ c(V, { orientation: "vertical", children: [
        /* @__PURE__ */ e(ce, { amount: s }),
        m.paidBy && /* @__PURE__ */ e(F.Text, { type: "secondary", children: `Paid by ${m.paidBy}` })
      ] })
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (s, m) => s.status.localeCompare(m.status),
      render: (s) => /* @__PURE__ */ e(We, { status: s })
    },
    {
      title: "Download PDF",
      dataIndex: "pdfUrl",
      render: (s, m) => /* @__PURE__ */ e("a", { href: s, "aria-label": `Download invoice ${m.id}`, children: "PDF" })
    }
  ], a = Array.from(new Set(t.map((s) => s.status)));
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ e(
      Ie,
      {
        placeholder: "Status",
        value: r === "ALL" ? void 0 : r,
        allowClear: !0,
        onChange: (s) => o(s ?? "ALL"),
        style: { width: 160, marginBottom: 16 },
        children: a.map((s) => /* @__PURE__ */ e(Ie.Option, { value: s, children: s }, s))
      }
    ),
    Object.entries(l).map(([s, m]) => /* @__PURE__ */ c(
      "div",
      {
        "data-testid": `season-${s}`,
        style: { marginBottom: n ? 16 : 0 },
        children: [
          n && /* @__PURE__ */ e(F.Title, { level: 5, style: { marginTop: 0 }, children: s }),
          /* @__PURE__ */ e(K, { rowKey: "id", columns: u, dataSource: m, pagination: !1 })
        ]
      },
      s
    ))
  ] });
}, mr = "_invoiceModal_djzrq_1", hr = "_fullWidth_djzrq_5", pr = "_summaryCell_djzrq_8", gr = "_notesDivider_djzrq_17", fr = "_notesParagraph_djzrq_21", me = {
  invoiceModal: mr,
  fullWidth: hr,
  summaryCell: pr,
  notesDivider: gr,
  notesParagraph: fr
}, yr = ({ invoice: t }) => /* @__PURE__ */ c(K.Summary, { children: [
  /* @__PURE__ */ c(K.Summary.Row, { children: [
    /* @__PURE__ */ e(K.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "Sub-total" }),
    /* @__PURE__ */ e(K.Summary.Cell, { index: 3, align: "right", className: me.summaryCell, children: /* @__PURE__ */ e(ce, { amount: t.subTotal, currency: t.currency }) })
  ] }),
  t.discount !== void 0 && /* @__PURE__ */ c(K.Summary.Row, { children: [
    /* @__PURE__ */ e(K.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "Discount" }),
    /* @__PURE__ */ e(K.Summary.Cell, { index: 3, align: "right", className: me.summaryCell, children: /* @__PURE__ */ e(ce, { amount: t.discount, currency: t.currency }) })
  ] }),
  t.otherCharges !== void 0 && /* @__PURE__ */ c(K.Summary.Row, { children: [
    /* @__PURE__ */ e(K.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "Other Charges" }),
    /* @__PURE__ */ e(K.Summary.Cell, { index: 3, align: "right", className: me.summaryCell, children: /* @__PURE__ */ e(ce, { amount: t.otherCharges, currency: t.currency }) })
  ] }),
  /* @__PURE__ */ c(K.Summary.Row, { children: [
    /* @__PURE__ */ e(K.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "VAT" }),
    /* @__PURE__ */ e(K.Summary.Cell, { index: 3, align: "right", className: me.summaryCell, children: /* @__PURE__ */ e(ce, { amount: t.vat, currency: t.currency }) })
  ] }),
  /* @__PURE__ */ c(K.Summary.Row, { children: [
    /* @__PURE__ */ e(K.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: /* @__PURE__ */ e(F.Text, { strong: !0, children: "Grand Total" }) }),
    /* @__PURE__ */ e(K.Summary.Cell, { index: 3, align: "right", className: me.summaryCell, children: /* @__PURE__ */ e(ce, { amount: t.grandTotal, currency: t.currency }) })
  ] })
] }), Ti = ({
  visible: t,
  invoice: n,
  onClose: r,
  onDownloadPdf: o,
  onDelete: i
}) => {
  const [l, u] = j.useState(null), a = [
    { title: "Description", dataIndex: "description", key: "description" },
    { title: "Qty", dataIndex: "qty", key: "qty", align: "right" },
    {
      title: "Unit Price",
      dataIndex: "unitPrice",
      key: "unitPrice",
      render: (m) => /* @__PURE__ */ e(ce, { amount: m, currency: n.currency }),
      align: "right"
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      render: (m) => /* @__PURE__ */ e(ce, { amount: m, currency: n.currency }),
      align: "right"
    },
    {
      title: "Delete",
      key: "delete",
      align: "center",
      render: (m, h) => /* @__PURE__ */ e(
        E,
        {
          icon: /* @__PURE__ */ e(kt, {}),
          "aria-label": "Delete line",
          onClick: () => u(h.id)
        }
      )
    }
  ], s = () => {
    typeof window < "u" && typeof window.print == "function" && window.print();
  };
  return /* @__PURE__ */ c(be, { children: [
    /* @__PURE__ */ e(
      Me,
      {
        title: null,
        open: t,
        onCancel: r,
        footer: null,
        width: 720,
        rootClassName: me.invoiceModal,
        destroyOnClose: !0,
        children: /* @__PURE__ */ c(V, { orientation: "vertical", className: me.fullWidth, size: "middle", children: [
          /* @__PURE__ */ c(V, { align: "center", wrap: !0, children: [
            /* @__PURE__ */ e(rt, { size: "small" }),
            /* @__PURE__ */ e(F.Text, { strong: !0, children: n.memberName }),
            /* @__PURE__ */ e(F.Text, { children: "-" }),
            /* @__PURE__ */ e(F.Text, { children: n.invoiceNumber }),
            /* @__PURE__ */ e(We, { status: n.status })
          ] }),
          /* @__PURE__ */ c(le, { column: 1, size: "small", children: [
            /* @__PURE__ */ e(le.Item, { label: "Issuer", children: n.issuerAddress }),
            /* @__PURE__ */ e(le.Item, { label: "Recipient", children: n.recipientAddress }),
            /* @__PURE__ */ e(le.Item, { label: "Issue Date", children: ae(n.issueDate).format("YYYY-MM-DD") }),
            /* @__PURE__ */ e(le.Item, { label: "Due Date", children: ae(n.dueDate).format("YYYY-MM-DD") })
          ] }),
          /* @__PURE__ */ e(
            K,
            {
              rowKey: "id",
              dataSource: n.lines,
              columns: a,
              pagination: !1,
              size: "small",
              summary: () => /* @__PURE__ */ e(yr, { invoice: n })
            }
          ),
          n.notes && /* @__PURE__ */ c(be, { children: [
            /* @__PURE__ */ e(Yt, { className: me.notesDivider }),
            /* @__PURE__ */ e(F.Paragraph, { className: me.notesParagraph, children: n.notes })
          ] }),
          /* @__PURE__ */ c(Ye, { justify: "space-between", align: "middle", className: me.fullWidth, children: [
            /* @__PURE__ */ e(Oe, { children: o && /* @__PURE__ */ e(
              E,
              {
                icon: /* @__PURE__ */ e(on, {}),
                onClick: () => o(n.id),
                "aria-label": "Download PDF",
                children: "Download PDF"
              }
            ) }),
            /* @__PURE__ */ e(Oe, { children: /* @__PURE__ */ c(V, { children: [
              /* @__PURE__ */ e(E, { icon: /* @__PURE__ */ e(an, {}), onClick: s, "aria-label": "Print", children: "Print" }),
              /* @__PURE__ */ e(E, { type: "primary", onClick: r, "aria-label": "Close invoice preview", children: "Close" })
            ] }) })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ e(
      Me,
      {
        open: l !== null,
        title: "Delete line?",
        onOk: () => {
          l && i?.(l), u(null);
        },
        onCancel: () => u(null),
        okText: "Delete",
        cancelText: "Cancel",
        children: /* @__PURE__ */ e(F.Paragraph, { children: "Are you sure you want to remove this line item from the invoice?" })
      }
    )
  ] });
}, _i = ({ data: t = [] }) => {
  const n = Array.isArray(t) ? t : [];
  return /* @__PURE__ */ e(Te, { title: "Feature Usage", bordered: !1, children: /* @__PURE__ */ e("div", { role: "list", style: { display: "flex", flexDirection: "column", gap: 8 }, children: (n.length ? n : [{ feature: "N/A", count: 0 }]).map(({ feature: r, count: o }) => /* @__PURE__ */ c(
    "div",
    {
      role: "listitem",
      style: {
        display: "flex",
        justifyContent: "space-between",
        padding: "6px 0",
        borderBottom: "1px solid #f0f0f0"
      },
      children: [
        /* @__PURE__ */ e("div", { children: r }),
        /* @__PURE__ */ e("div", { children: o })
      ]
    },
    r
  )) }) });
}, Ni = ({ data: t = [] }) => /* @__PURE__ */ e(Te, { title: "System Health", bordered: !1, children: t.length ? t.map(({ name: n, value: r }) => /* @__PURE__ */ c("div", { style: { marginBottom: 8 }, children: [
  /* @__PURE__ */ e("div", { children: n }),
  /* @__PURE__ */ e(Kt, { percent: r, size: "small" })
] }, n)) : /* @__PURE__ */ e("div", { children: "No data" }) }), br = new kn(), Sr = (t) => vn({
  mutationKey: ["tenantsControllerCreateTenant"],
  mutationFn: (n) => br.tenantsControllerCreateTenant(
    n[0],
    n[1]
  ).then(({ data: r }) => r),
  ...t
}), Ai = ({
  open: t,
  onClose: n,
  initialStep: r = 0
}) => {
  const [o, i] = L(r), [l, u] = L({
    name: "",
    email: ""
  }), [a, s] = L(), [m, h] = L([]), g = Sr(), _ = o === 0 && !l.name || o === 1 && !a, C = async () => {
    try {
      const f = { name: l.name };
      await g.mutateAsync([f]), n();
    } catch {
    }
  };
  return /* @__PURE__ */ c(It, { open: t, onClose: n, size: 520, children: [
    /* @__PURE__ */ e(
      et,
      {
        current: o,
        items: [{ title: "Tenant details" }, { title: "Plan selection" }, { title: "Options" }],
        style: { marginBottom: 24 }
      }
    ),
    o === 0 && /* @__PURE__ */ c(v, { layout: "vertical", children: [
      /* @__PURE__ */ e(v.Item, { label: "Name", required: !0, children: /* @__PURE__ */ e(
        W,
        {
          value: l.name,
          onChange: (f) => u({ ...l, name: f.target.value })
        }
      ) }),
      /* @__PURE__ */ e(v.Item, { label: "Email", required: !0, children: /* @__PURE__ */ e(
        W,
        {
          value: l.email,
          onChange: (f) => u({ ...l, email: f.target.value })
        }
      ) })
    ] }),
    o === 1 && /* @__PURE__ */ e(v, { layout: "vertical", children: /* @__PURE__ */ e(v.Item, { label: "Plan", required: !0, children: /* @__PURE__ */ c(Le.Group, { value: a, onChange: (f) => s(f.target.value), children: [
      /* @__PURE__ */ e(Le, { value: "basic", children: "Basic" }),
      /* @__PURE__ */ e(Le, { value: "pro", children: "Pro" })
    ] }) }) }),
    o === 2 && /* @__PURE__ */ e(v, { layout: "vertical", children: /* @__PURE__ */ e(v.Item, { label: "Modules", children: /* @__PURE__ */ c(De.Group, { value: m, onChange: (f) => h(f), children: [
      /* @__PURE__ */ e(De, { value: "sms", children: "SMS" }),
      /* @__PURE__ */ e(De, { value: "reports", children: "Reports" })
    ] }) }) }),
    /* @__PURE__ */ c("div", { style: { marginTop: 24 }, children: [
      o > 0 && /* @__PURE__ */ e(E, { onClick: () => i(o - 1), style: { marginRight: 8 }, children: "Back" }),
      o < 2 && /* @__PURE__ */ e(E, { type: "primary", onClick: () => i(o + 1), disabled: !!_, children: "Next" }),
      o === 2 && /* @__PURE__ */ e(E, { type: "primary", onClick: C, style: { marginRight: 8 }, children: "Finish" }),
      /* @__PURE__ */ e(E, { onClick: n, children: "Cancel" })
    ] })
  ] });
}, Ft = $t({
  appName: "MyWebApp"
}), Li = () => Ot(Ft), Di = ({
  children: t,
  appName: n
}) => {
  const [r] = L(() => new wn());
  return /* @__PURE__ */ e(Ft.Provider, { value: { appName: n }, children: /* @__PURE__ */ e(xn, { client: r, children: t }) });
}, Ii = ({
  open: t,
  sizes: n,
  onAdd: r,
  onCancel: o
}) => {
  const [i, l] = L();
  return /* @__PURE__ */ e(
    Me,
    {
      title: "Choose Size",
      open: t,
      onOk: () => {
        i && r(i);
      },
      onCancel: o,
      okButtonProps: { disabled: !i },
      children: /* @__PURE__ */ e(Le.Group, { onChange: (a) => l(a.target.value), value: i, children: n.map((a) => /* @__PURE__ */ e(Le, { value: a, "aria-label": `size-${a}`, children: a }, a)) })
    }
  );
}, Ze = "id", { Dragger: vr } = Qt, wr = (t, n) => {
  const r = t.trim().split(/\r?\n/);
  if (!r.length) return [];
  const o = n ?? (r.length > 0 ? r.shift()?.split(",") ?? [] : []);
  return r.map((i, l) => {
    const u = i.split(","), a = o.reduce((s, m, h) => (s[m] = u[h] ?? "", s), {});
    return { [Ze]: l, ...a };
  });
}, Mi = ({ onUpload: t, headers: n }) => {
  const [r, o] = L([]), i = async (s) => "text" in s && typeof s.text == "function" ? s.text() : new Promise((m, h) => {
    const g = new FileReader();
    g.onload = () => m(g.result), g.onerror = () => h(g.error), g.readAsText(s);
  }), l = async (s) => {
    const m = await i(s), h = wr(m, n);
    return o(h), t(h, s), !1;
  }, a = (n ?? (r[0] ? Object.keys(r[0]).filter((s) => s !== Ze) : [])).map((s) => ({
    title: s,
    dataIndex: s,
    key: s
  }));
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ c(
      vr,
      {
        beforeUpload: l,
        showUploadList: !1,
        style: { marginBottom: 16 },
        "data-testid": "dropzone",
        children: [
          /* @__PURE__ */ e("p", { className: "ant-upload-drag-icon", children: /* @__PURE__ */ e(ln, {}) }),
          /* @__PURE__ */ e("p", { className: "ant-upload-text", children: "Click or drag CSV file to this area to upload" })
        ]
      }
    ),
    r.length > 0 && /* @__PURE__ */ e(K, { dataSource: r, columns: a, pagination: !1, rowKey: Ze })
  ] });
}, xr = ({ onSubmit: t, submitting: n }) => {
  const [r] = v.useForm();
  return /* @__PURE__ */ c(v, { form: r, layout: "vertical", onFinish: t, children: [
    /* @__PURE__ */ e(v.Item, { label: "First name", name: "firstName", rules: [{ required: !0 }], children: /* @__PURE__ */ e(W, {}) }),
    /* @__PURE__ */ e(v.Item, { label: "Last name", name: "lastName", rules: [{ required: !0 }], children: /* @__PURE__ */ e(W, {}) }),
    /* @__PURE__ */ e(v.Item, { label: "Email", name: "email", rules: [{ required: !0, type: "email" }], children: /* @__PURE__ */ e(W, { type: "email" }) }),
    /* @__PURE__ */ e(v.Item, { label: "Phone", name: "phone", children: /* @__PURE__ */ e(W, {}) }),
    /* @__PURE__ */ e(v.Item, { label: "Date of birth", name: "dateOfBirth", children: /* @__PURE__ */ e(xt, { style: { width: "100%" } }) }),
    /* @__PURE__ */ e(v.Item, { label: "Club ID", name: "clubId", rules: [{ required: !0 }], children: /* @__PURE__ */ e(W, { type: "number" }) }),
    /* @__PURE__ */ e(v.Item, { children: /* @__PURE__ */ e(E, { type: "primary", htmlType: "submit", loading: n, children: "Submit" }) })
  ] });
}, Ui = () => {
  const { message: t } = Se.useApp(), [n, r] = L(!1);
  return /* @__PURE__ */ e(xr, { onSubmit: async (i) => {
    r(!0);
    try {
      const l = await globalThis.fetch("/api/members/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...i, clubId: Number(i.clubId) })
      });
      if (!l.ok)
        throw new Error(l.statusText || "Signup failed");
      t.success("Signup successful");
    } catch (l) {
      const u = l;
      t.error(u.message || "Signup failed");
    } finally {
      r(!1);
    }
  }, submitting: n });
}, Ei = ({
  label: t,
  error: n,
  id: r,
  className: o = "",
  ...i
}) => {
  const l = r ?? i.name ?? t;
  return /* @__PURE__ */ c("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ e("label", { htmlFor: l, className: "mb-1 text-sm font-medium", children: t }),
    /* @__PURE__ */ e(
      "input",
      {
        id: l,
        className: `border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent ${n ? "border-red-500" : "border-gray-300"} ${o}`,
        ...i
      }
    ),
    n && /* @__PURE__ */ e("p", { className: "mt-1 text-xs text-red-500", children: n })
  ] });
}, Fi = ({
  children: t,
  loading: n,
  block: r,
  className: o = "",
  disabled: i,
  ...l
}) => /* @__PURE__ */ e(
  "button",
  {
    className: `bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50 ${r ? "w-full" : ""} ${o}`,
    disabled: i || n,
    ...l,
    children: n ? "Loading..." : t
  }
);
function Pi({
  size: t = "middle",
  showTooltip: n = !0,
  className: r
}) {
  const { mode: o, toggleTheme: i } = Ct(), l = o === "dark", u = /* @__PURE__ */ e(
    E,
    {
      type: "text",
      size: t,
      icon: l ? /* @__PURE__ */ e(sn, {}) : /* @__PURE__ */ e(cn, {}),
      onClick: i,
      className: r,
      "aria-label": l ? "Switch to light mode" : "Switch to dark mode",
      style: {
        color: "inherit"
      }
    }
  );
  return n ? /* @__PURE__ */ e(vt, { title: l ? "Light mode" : "Dark mode", children: u }) : u;
}
const kr = "_loginContainer_10ohu_3", Cr = "_heroSection_10ohu_12", Tr = "_heroContent_10ohu_27", _r = "_heroTitle_10ohu_35", Nr = "_heroSubtitle_10ohu_44", Ar = "_heroFeatures_10ohu_51", Lr = "_heroFeature_10ohu_51", Dr = "_heroFeatureIcon_10ohu_66", Ir = "_floatingShapes_10ohu_78", Mr = "_shape_10ohu_86", Ur = "_shape1_10ohu_93", Er = "_shape2_10ohu_101", Fr = "_shape3_10ohu_109", Pr = "_loginContent_10ohu_133", Br = "_background_10ohu_153", Rr = "_gradientOverlay_10ohu_159", $r = "_loginCard_10ohu_164", Or = "_logoContainer_10ohu_214", zr = "_title_10ohu_219", Wr = "_subtitle_10ohu_230", qr = "_errorAlert_10ohu_237", Hr = "_ssoButtonsContainer_10ohu_243", Vr = "_ssoButtonGoogle_10ohu_273 _ssoButton_10ohu_243", jr = "_ssoButtonFacebook_10ohu_277 _ssoButton_10ohu_243", Gr = "_dividerWrapper_10ohu_290", Yr = "_dividerLine_10ohu_299", Kr = "_formGroup_10ohu_306", Qr = "_formLabel_10ohu_310", Xr = "_formInput_10ohu_318", Zr = "_optionsRow_10ohu_331", Jr = "_rememberMe_10ohu_338", eo = "_forgotLink_10ohu_343", to = "_submitButton_10ohu_356", no = "_signupText_10ohu_383", ro = "_signupLink_10ohu_392", oo = "_mfaToggle_10ohu_410", io = "_mfaCard_10ohu_414", ao = "_fullWidth_10ohu_445", T = {
  loginContainer: kr,
  heroSection: Cr,
  heroContent: Tr,
  heroTitle: _r,
  heroSubtitle: Nr,
  heroFeatures: Ar,
  heroFeature: Lr,
  heroFeatureIcon: Dr,
  floatingShapes: Ir,
  shape: Mr,
  shape1: Ur,
  shape2: Er,
  shape3: Fr,
  loginContent: Pr,
  background: Br,
  gradientOverlay: Rr,
  loginCard: $r,
  logoContainer: Or,
  title: zr,
  subtitle: Wr,
  errorAlert: qr,
  ssoButtonsContainer: Hr,
  ssoButtonGoogle: Vr,
  ssoButtonFacebook: jr,
  dividerWrapper: Gr,
  dividerLine: Yr,
  formGroup: Kr,
  formLabel: Qr,
  formInput: Xr,
  optionsRow: Zr,
  rememberMe: Jr,
  forgotLink: eo,
  submitButton: to,
  signupText: no,
  signupLink: ro,
  mfaToggle: oo,
  mfaCard: io,
  fullWidth: ao
}, lo = () => {
  try {
    const t = require("@digiwedge/ui-theme");
    if (t?.useTheme) return t.useTheme;
    if (t?.default?.useTheme) return t.default.useTheme;
  } catch {
  }
  return () => ({ mode: "light" });
}, so = lo(), { Content: co } = ie, { Title: uo, Text: _e } = F;
function mo(t, n = "") {
  const r = typeof process < "u" ? process.env?.[t] : void 0, o = globalThis.importMetaEnv?.[t];
  return r ?? o ?? n;
}
const ho = ({ style: t }) => /* @__PURE__ */ c(
  "svg",
  {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    focusable: "false",
    "aria-hidden": "true",
    style: { display: "inline-block", verticalAlign: "middle", ...t },
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#4285F4",
          d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#34A853",
          d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#FBBC05",
          d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#EA4335",
          d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        }
      )
    ]
  }
), Bi = ({
  appName: t,
  asModal: n = !1,
  backgroundClassName: r,
  backgroundImageUrl: o,
  overlay: i,
  onCloseModal: l,
  defaultEmail: u,
  defaultRemember: a,
  placeholderEmail: s,
  placeholderPassword: m,
  logoLightSrc: h,
  logoDarkSrc: g,
  signupPath: _,
  forgotPasswordPath: C,
  heroTitle: f,
  heroSubtitle: S
}) => {
  const b = re(() => {
    const z = typeof t == "string" ? t.trim() : "";
    if (z && z.toLowerCase() !== "undefined" && z.toLowerCase() !== "null")
      return z;
    const O = typeof document < "u" ? document.title : "", Q = typeof O == "string" ? O.trim() : "";
    return Q && Q.toLowerCase() !== "undefined" && Q.toLowerCase() !== "null" ? Q : "DigiWedge";
  }, [t]), { mode: I } = so(), p = I === "dark" ? "dark" : "light", { login: N, loading: q, error: H } = Tt(), { verifyLoginMfa: x, loading: P } = Tn(), [M, y] = L(() => ({
    email: u ?? "",
    password: "",
    remember: !!a
  })), [D, A] = L({}), [w, U] = L(!1), [B, R] = L(""), [ne, X] = L(""), [Ue, Z] = L(!1), [ke, se] = L(null), { message: Ee } = Se.useApp(), Fe = (z) => (O) => y((Q) => ({
    ...Q,
    [z]: O.target.value
  })), qe = (z) => y((O) => ({
    ...O,
    remember: z.target.checked
  })), J = j.useCallback(
    (z, O, Q) => {
      Promise.resolve().then(() => {
        const ue = Q ? /* @__PURE__ */ c("span", { children: [
          /* @__PURE__ */ e("span", { children: O }),
          /* @__PURE__ */ e("div", { style: { fontSize: 12, opacity: 0.85 }, children: Q })
        ] }) : O;
        Ee.open({ type: z, content: ue });
      });
    },
    [Ee]
  ), He = async (z) => {
    z.preventDefault();
    const O = {};
    if (M.email ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(M.email) || (O.email = d("en-US", "loginInvalidEmail")) : O.email = d("en-US", "loginEmailRequired"), M.password || (O.password = d("en-US", "loginPasswordRequired")), A(O), !Object.keys(O).length)
      try {
        if ((await N(M))?.mfaRequired) {
          J("info", "Verification code sent. Check your phone."), U(!0);
          return;
        }
        J("success", d("en-US", "loginSuccess"));
        try {
          if (typeof window < "u" && "BroadcastChannel" in window) {
            const ue = new BroadcastChannel("auth");
            ue.postMessage({ type: "login", at: Date.now() }), ue.close();
          }
        } catch {
        }
        window.location.href = "/";
      } catch (Q) {
        const ue = Q?.message || "";
        /401|invalid/i.test(ue) ? J("error", "Email or password is incorrect.") : /423|lock/i.test(ue) ? J("error", "Your account is temporarily locked. Try again later or reset your password.") : /429|rate|too many/i.test(ue) ? J("error", "Too many attempts. Please wait a moment and try again.") : J("error", d("en-US", "loginError"));
      }
  }, k = re(
    () => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(M.email),
    [M.email]
  ), $ = re(() => M.password.length > 0, [M.password]), G = k && $, ee = mo("VITE_IDP_BASE_URL", "https://idp.uat.digiwedge.com").replace(/\/$/, ""), pe = encodeURIComponent(window.location.origin + "/"), ye = _ ?? "/signup", Ce = C ?? `${ee}/forgot-password`, ge = (z) => {
    const O = z === "google" ? "/api/auth/google" : "/api/auth/facebook";
    window.location.href = `${ee}${O}?returnTo=${pe}`;
  }, Ve = async () => {
    if (se(null), !ne || !B) {
      se("Enter your User ID and the 6-digit code.");
      return;
    }
    try {
      Z(!0), await x({
        userId: ne,
        code: B,
        rememberDevice: !0,
        deviceInfo: navigator.userAgent,
        // persist according to the original selection
        remember: M.remember
      }), J("success", d("en-US", "loginSuccess")), U(!1), window.location.href = "/";
    } catch (z) {
      if (Dn(z)) {
        const { code: O, message: Q } = _n(z, "Verification failed");
        se(O === "otp-invalid" ? "Invalid code. Please try again." : O === "otp-expired" ? "Code expired. Request a new code." : O === "otp-rate-limited" ? "Too many attempts. Please wait and try again." : O === "server-error" || O === "network-error" ? `${Q}. You can try again.` : Q);
      } else
        se("Verification failed");
    } finally {
      Z(!1);
    }
  };
  oe(() => {
    w || (X(""), R(""), se(null));
  }, [w]), oe(() => {
    const { pathname: z } = window.location, O = In(window.location);
    if (!O) return;
    const { code: Q, provider: ue = "", description: Pt } = O, je = ue.toLowerCase(), at = (Pt || "").trim(), lt = je ? je.charAt(0).toUpperCase() + je.slice(1) : "Social account";
    Q === "not-linked" ? J(
      "error",
      `${lt} is not linked to your account yet. Sign in with your email to finish linking.`
    ) : Q === "oauth-failed" ? J("error", `${lt} authentication failed.`, at || void 0) : J("error", "Authentication failed.", at || void 0), window.history.replaceState(null, "", z);
  }, [J]);
  const Pe = [
    "Secure single sign-on",
    "Multi-factor authentication",
    "Enterprise-grade security"
  ], it = /* @__PURE__ */ c(Te, { className: T.loginCard, bordered: !1, children: [
    /* @__PURE__ */ e("div", { className: T.logoContainer, children: /* @__PURE__ */ e(
      rt,
      {
        themeMode: p,
        size: "medium",
        lightLogoSrc: h,
        darkLogoSrc: g
      }
    ) }),
    /* @__PURE__ */ e(uo, { level: 3, className: T.title, children: "Welcome back" }),
    /* @__PURE__ */ c(_e, { className: T.subtitle, children: [
      "Sign in to continue to ",
      b
    ] }),
    H && /* @__PURE__ */ e(
      $e,
      {
        message: d("en-US", "loginFailedTitle"),
        description: /401|invalid/i.test(H.message) ? "Email or password incorrect." : /423|lock/i.test(H.message) ? "Your account is locked due to multiple failed attempts." : H?.message,
        type: "error",
        showIcon: !0,
        className: T.errorAlert
      }
    ),
    /* @__PURE__ */ c("div", { className: T.ssoButtonsContainer, children: [
      /* @__PURE__ */ c(
        "button",
        {
          type: "button",
          className: T.ssoButtonGoogle,
          onClick: () => ge("google"),
          children: [
            /* @__PURE__ */ e(ho, {}),
            /* @__PURE__ */ e("span", { children: "Continue with Google" })
          ]
        }
      ),
      /* @__PURE__ */ c(
        "button",
        {
          type: "button",
          className: T.ssoButtonFacebook,
          onClick: () => ge("facebook"),
          children: [
            /* @__PURE__ */ e(dn, { style: { fontSize: 20 } }),
            /* @__PURE__ */ e("span", { children: "Continue with Facebook" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ c("div", { className: T.dividerWrapper, children: [
      /* @__PURE__ */ e("div", { className: T.dividerLine }),
      /* @__PURE__ */ e("span", { children: "or continue with email" }),
      /* @__PURE__ */ e("div", { className: T.dividerLine })
    ] }),
    /* @__PURE__ */ c("form", { onSubmit: He, children: [
      /* @__PURE__ */ c("div", { className: T.formGroup, children: [
        /* @__PURE__ */ e("label", { className: T.formLabel, htmlFor: "email", children: "Email address" }),
        /* @__PURE__ */ e(
          W,
          {
            type: "email",
            size: "large",
            id: "email",
            className: T.formInput,
            value: M.email,
            onChange: Fe("email"),
            autoComplete: "username",
            status: D.email ? "error" : "",
            placeholder: s || "you@example.com"
          }
        ),
        D.email && /* @__PURE__ */ e(_e, { type: "danger", style: { fontSize: 12, marginTop: 4 }, children: D.email })
      ] }),
      /* @__PURE__ */ c("div", { className: T.formGroup, children: [
        /* @__PURE__ */ e("label", { className: T.formLabel, htmlFor: "password", children: "Password" }),
        /* @__PURE__ */ e(
          W.Password,
          {
            size: "large",
            id: "password",
            className: T.formInput,
            value: M.password,
            onChange: Fe("password"),
            autoComplete: "current-password",
            status: D.password ? "error" : "",
            placeholder: m || "Enter your password"
          }
        ),
        D.password && /* @__PURE__ */ e(_e, { type: "danger", style: { fontSize: 12, marginTop: 4 }, children: D.password })
      ] }),
      /* @__PURE__ */ c("div", { className: T.optionsRow, children: [
        /* @__PURE__ */ e(
          De,
          {
            checked: M.remember,
            onChange: qe,
            className: T.rememberMe,
            children: "Remember me"
          }
        ),
        C ? /* @__PURE__ */ e(ze, { to: C, className: T.forgotLink, children: "Forgot password?" }) : /* @__PURE__ */ e("a", { href: Ce, className: T.forgotLink, children: "Forgot password?" })
      ] }),
      /* @__PURE__ */ e(
        E,
        {
          htmlType: "submit",
          type: "primary",
          size: "large",
          disabled: !G || q,
          loading: q,
          block: !0,
          className: T.submitButton,
          children: "Sign in"
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { className: T.mfaToggle, children: /* @__PURE__ */ e(
      Xt,
      {
        activeKey: w ? ["mfa"] : [],
        onChange: (z) => {
          const O = Array.isArray(z) ? z.includes("mfa") : !!z;
          U(O);
        },
        ghost: !0,
        items: [
          {
            key: "mfa",
            label: /* @__PURE__ */ e(_e, { type: "secondary", children: "Have a verification code?" }),
            children: /* @__PURE__ */ e("div", { className: T.mfaCard, children: /* @__PURE__ */ c(V, { direction: "vertical", className: T.fullWidth, size: "middle", children: [
              /* @__PURE__ */ e(
                W,
                {
                  placeholder: "User ID (UUID)",
                  value: ne,
                  onChange: (z) => X(z.target.value),
                  size: "large",
                  className: T.formInput
                }
              ),
              /* @__PURE__ */ e(
                W,
                {
                  placeholder: "6-digit code",
                  inputMode: "numeric",
                  value: B,
                  onChange: (z) => R(z.target.value.replace(/\D/g, "")),
                  maxLength: 6,
                  size: "large",
                  className: T.formInput
                }
              ),
              ke && /* @__PURE__ */ e($e, { type: "error", message: ke, showIcon: !0 }),
              /* @__PURE__ */ e(
                E,
                {
                  type: "primary",
                  onClick: Ve,
                  loading: Ue || P,
                  block: !0,
                  size: "large",
                  className: T.submitButton,
                  children: "Verify"
                }
              )
            ] }) })
          }
        ]
      }
    ) }),
    /* @__PURE__ */ e("div", { className: T.signupText, children: /* @__PURE__ */ c(_e, { children: [
      d("en-US", "dontHaveAccount"),
      /* @__PURE__ */ e(ze, { to: ye, className: T.signupLink, children: d("en-US", "signUpButton") })
    ] }) })
  ] });
  return n ? /* @__PURE__ */ e(
    Me,
    {
      open: !0,
      centered: !0,
      footer: null,
      onCancel: l,
      width: 480,
      destroyOnHidden: !0,
      closable: !0,
      maskClosable: !0,
      keyboard: !0,
      styles: { content: { padding: 0, borderRadius: 24, overflow: "hidden" } },
      children: it
    }
  ) : /* @__PURE__ */ c(ie, { className: T.loginContainer, children: [
    /* @__PURE__ */ c("div", { className: T.heroSection, children: [
      /* @__PURE__ */ c("div", { className: T.floatingShapes, children: [
        /* @__PURE__ */ e("div", { className: `${T.shape} ${T.shape1}` }),
        /* @__PURE__ */ e("div", { className: `${T.shape} ${T.shape2}` }),
        /* @__PURE__ */ e("div", { className: `${T.shape} ${T.shape3}` })
      ] }),
      /* @__PURE__ */ c("div", { className: T.heroContent, children: [
        /* @__PURE__ */ e("h1", { className: T.heroTitle, children: f || b }),
        /* @__PURE__ */ e("p", { className: T.heroSubtitle, children: S || "Your complete business management platform" }),
        /* @__PURE__ */ e("div", { className: T.heroFeatures, children: Pe.map((z, O) => /* @__PURE__ */ c("div", { className: T.heroFeature, children: [
          /* @__PURE__ */ e("span", { className: T.heroFeatureIcon, children: /* @__PURE__ */ e(un, { style: { color: "#fff", fontSize: 14 } }) }),
          /* @__PURE__ */ e("span", { children: z })
        ] }, O)) })
      ] })
    ] }),
    /* @__PURE__ */ e(
      "div",
      {
        className: `${T.background} ${r ?? ""}`,
        style: o ? {
          backgroundImage: `url(${o})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        } : void 0
      }
    ),
    i !== "none" && /* @__PURE__ */ e("div", { className: T.gradientOverlay }),
    /* @__PURE__ */ e(co, { className: T.loginContent, children: it })
  ] });
}, po = "_page_18e0n_1", go = "_shell_18e0n_9", fo = "_brandPanel_18e0n_20", yo = "_brandContent_18e0n_29", bo = "_brandBadge_18e0n_34", So = "_brandTitle_18e0n_46", vo = "_brandSubtitle_18e0n_51", wo = "_brandList_18e0n_55", xo = "_brandQuote_18e0n_63", ko = "_brandQuoteText_18e0n_71", Co = "_brandQuoteAuthor_18e0n_76", To = "_formPanel_18e0n_82", _o = "_formHeader_18e0n_89", No = "_alert_18e0n_94", Ao = "_footerRow_18e0n_98", Lo = "_link_18e0n_102", te = {
  page: po,
  shell: go,
  brandPanel: fo,
  brandContent: yo,
  brandBadge: bo,
  brandTitle: So,
  brandSubtitle: vo,
  brandList: wo,
  brandQuote: xo,
  brandQuoteText: ko,
  brandQuoteAuthor: Co,
  formPanel: To,
  formHeader: _o,
  alert: No,
  footerRow: Ao,
  link: Lo
}, { Title: yt, Text: Ne } = F, Do = [
  "Secure access with role-based permissions.",
  "Unified records across teams and workflows.",
  "Live reporting for confident decisions."
], Ri = ({
  appName: t,
  logoLightSrc: n,
  logoDarkSrc: r,
  highlights: o = Do,
  quote: i = '"Onboarding our team took minutes, not days."',
  quoteAuthor: l = "Operations Lead"
}) => {
  const { message: u } = Se.useApp(), { locale: a } = Cn(), s = nt(), { register: m, loading: h, error: g } = _t(), { token: _ } = Y.useToken(), C = j.useMemo(() => {
    const b = typeof t == "string" ? t.trim() : "";
    if (b && b.toLowerCase() !== "undefined" && b.toLowerCase() !== "null")
      return b;
    const I = typeof document < "u" ? document.title : "", p = typeof I == "string" ? I.trim() : "";
    return p && p.toLowerCase() !== "undefined" && p.toLowerCase() !== "null" ? p : "DigiWedge";
  }, [t]), f = async (b) => {
    try {
      await m(b), u.success(d(a, "registrationSuccess")), s("/login");
    } catch {
      u.error(d(a, "registrationError"));
    }
  }, S = {
    "--register-bg": _.colorBgLayout || "#f0f2f5",
    "--register-surface": _.colorBgContainer || "#ffffff",
    "--register-border": _.colorBorderSecondary || "#e6e8ec",
    "--register-primary": _.colorPrimary || "#1677ff"
  };
  return /* @__PURE__ */ e("div", { className: te.page, style: S, children: /* @__PURE__ */ c("div", { className: te.shell, children: [
    /* @__PURE__ */ c("aside", { className: te.brandPanel, children: [
      /* @__PURE__ */ e(
        rt,
        {
          themeMode: "dark",
          size: "medium",
          lightLogoSrc: n,
          darkLogoSrc: r,
          alt: `${C} logo`
        }
      ),
      /* @__PURE__ */ c("div", { className: te.brandContent, children: [
        /* @__PURE__ */ e("span", { className: te.brandBadge, children: d(a, "signUpButton") }),
        /* @__PURE__ */ c(yt, { level: 2, className: te.brandTitle, children: [
          "Create your ",
          C,
          " account"
        ] }),
        /* @__PURE__ */ e(Ne, { className: te.brandSubtitle, children: "Bring your team together with secure access and unified workflows." })
      ] }),
      /* @__PURE__ */ e("ul", { className: te.brandList, children: o.map((b) => /* @__PURE__ */ e("li", { children: b }, b)) }),
      /* @__PURE__ */ c("div", { className: te.brandQuote, children: [
        /* @__PURE__ */ e(Ne, { className: te.brandQuoteText, children: i }),
        /* @__PURE__ */ e(Ne, { className: te.brandQuoteAuthor, children: l })
      ] })
    ] }),
    /* @__PURE__ */ c("section", { className: te.formPanel, children: [
      /* @__PURE__ */ c("div", { className: te.formHeader, children: [
        /* @__PURE__ */ e(yt, { level: 3, children: d(a, "registerHeading").replace("{appName}", C) }),
        /* @__PURE__ */ e(Ne, { type: "secondary", children: "Fill in the details below to get started." })
      ] }),
      g && /* @__PURE__ */ e(
        $e,
        {
          message: d(a, "registrationFailedTitle"),
          description: g.message,
          type: "error",
          showIcon: !0,
          className: te.alert
        }
      ),
      /* @__PURE__ */ c(v, { name: "register", layout: "vertical", onFinish: f, children: [
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d(a, "emailLabel"),
            name: "email",
            rules: [
              {
                required: !0,
                message: d(a, "registerAccountEmailRequired")
              },
              {
                type: "email",
                message: d(a, "registerAccountInvalidEmail")
              }
            ],
            children: /* @__PURE__ */ e(W, { placeholder: d(a, "emailPlaceholder"), size: "large" })
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d(a, "passwordLabel"),
            name: "password",
            rules: [
              {
                required: !0,
                message: d(a, "registerAccountPasswordRequired")
              },
              {
                min: 8,
                message: d(a, "registerAccountPasswordMin")
              }
            ],
            children: /* @__PURE__ */ e(W.Password, { placeholder: d(a, "passwordPlaceholder"), size: "large" })
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d(a, "fullNameLabel"),
            name: "name",
            rules: [
              {
                required: !0,
                message: d(a, "fullNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(W, { placeholder: d(a, "fullNamePlaceholder"), size: "large" })
          }
        ),
        /* @__PURE__ */ e(v.Item, { label: d(a, "tenantIdLabel"), name: "tenantId", children: /* @__PURE__ */ e(W, { placeholder: d(a, "tenantIdPlaceholder"), size: "large" }) }),
        /* @__PURE__ */ e(v.Item, { label: d(a, "roleIdLabel"), name: "roleId", children: /* @__PURE__ */ e(W, { placeholder: d(a, "roleIdPlaceholder"), size: "large" }) }),
        /* @__PURE__ */ e(
          v.Item,
          {
            name: "termsAccepted",
            valuePropName: "checked",
            rules: [
              {
                validator: (b, I) => I ? Promise.resolve() : Promise.reject(new Error(d(a, "termsRequired")))
              }
            ],
            children: /* @__PURE__ */ e(De, { children: d(a, "termsAcceptLabel") })
          }
        ),
        /* @__PURE__ */ e(E, { type: "primary", htmlType: "submit", block: !0, size: "large", loading: h, children: d(a, "signUpButton") })
      ] }),
      /* @__PURE__ */ e("div", { className: te.footerRow, children: /* @__PURE__ */ c(Ne, { children: [
        d(a, "alreadyHaveAccount"),
        " ",
        /* @__PURE__ */ e(ze, { to: "/login", className: te.link, children: d(a, "loginLinkText") })
      ] }) })
    ] })
  ] }) });
}, $i = () => {
  const t = nt(), { logout: n } = Nn(), { token: r } = Y.useToken(), { message: o } = Se.useApp();
  return oe(() => {
    (async () => {
      try {
        await n(), o.success(d("en-US", "logoutSuccess"));
      } catch {
        o.error(d("en-US", "logoutError"));
      } finally {
        t("/login");
      }
    })();
  }, [n, t, o]), /* @__PURE__ */ e(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: r.colorBgContainer
      },
      children: /* @__PURE__ */ e(St, { tip: d("en-US", "logoutProgress"), size: "large" })
    }
  );
}, Io = () => /* @__PURE__ */ c("div", { children: [
  /* @__PURE__ */ e("h2", { children: d("en-US", "registrationComplete") }),
  /* @__PURE__ */ e("p", { children: d("en-US", "registrationCompleteDetail") }),
  /* @__PURE__ */ e("p", { children: /* @__PURE__ */ e("a", { href: "/login", children: d("en-US", "goToLogin") }) })
] }), Mo = ({
  onNext: t,
  loading: n,
  serverError: r
}) => {
  const { message: o } = Se.useApp(), [i] = v.useForm();
  return oe(() => {
    if (r?.fieldErrors) {
      const u = Object.entries(r.fieldErrors).map(
        ([a, s]) => ({
          name: [a],
          errors: [s]
        })
      );
      i.setFields(u);
    }
  }, [r, i]), /* @__PURE__ */ e("div", { children: /* @__PURE__ */ c(
    v,
    {
      form: i,
      layout: "vertical",
      onFinish: async (u) => {
        try {
          await t(u);
        } catch {
          o.error(d("en-US", "registrationSubmitError"));
        }
      },
      onFinishFailed: (u) => {
        process.env.NODE_ENV !== "test" && console.warn("Validation Failed:", u);
      },
      children: [
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d("en-US", "emailLabel"),
            name: "email",
            rules: [
              {
                required: !0,
                message: d("en-US", "registerAccountEmailRequired")
              },
              {
                type: "email",
                message: d("en-US", "registerAccountInvalidEmail")
              }
            ],
            children: /* @__PURE__ */ e(W, {})
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d("en-US", "passwordLabel"),
            name: "password",
            rules: [
              {
                required: !0,
                message: d("en-US", "registerAccountPasswordRequired")
              },
              {
                min: 8,
                message: d("en-US", "registerAccountPasswordMin")
              },
              {
                validator: (u, a) => {
                  if (!a) return Promise.resolve();
                  const s = /[A-Z]/.test(a), m = /[a-z]/.test(a), h = /\d/.test(a);
                  return !s || !m || !h ? Promise.reject(d("en-US", "registerAccountPasswordComplex")) : Promise.resolve();
                }
              }
            ],
            children: /* @__PURE__ */ e(W.Password, {})
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d("en-US", "firstNameLabel"),
            name: "givenName",
            rules: [
              {
                required: !0,
                message: d("en-US", "registerAccountFirstNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(W, {})
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d("en-US", "lastNameLabel"),
            name: "familyName",
            rules: [
              {
                required: !0,
                message: d("en-US", "registerAccountLastNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(W, {})
          }
        ),
        /* @__PURE__ */ e(v.Item, { label: d("en-US", "preferredNameLabel"), name: "preferredName", children: /* @__PURE__ */ e(W, {}) }),
        /* @__PURE__ */ e(E, { type: "primary", htmlType: "submit", block: !0, loading: n, children: d("en-US", "registerButton") })
      ]
    }
  ) });
}, Uo = ({ onLogin: t, loading: n }) => {
  const [r] = v.useForm();
  async function o(i) {
    await t(i);
  }
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ e("h2", { children: d("en-US", "loginHeading") }),
    /* @__PURE__ */ c(
      v,
      {
        form: r,
        layout: "vertical",
        onFinish: o,
        initialValues: { email: "", password: "" },
        children: [
          /* @__PURE__ */ e(
            v.Item,
            {
              label: d("en-US", "emailLabel"),
              name: "email",
              rules: [
                {
                  required: !0,
                  message: d("en-US", "loginEmailRequired")
                },
                {
                  type: "email",
                  message: d("en-US", "loginInvalidEmail")
                }
              ],
              children: /* @__PURE__ */ e(W, {})
            }
          ),
          /* @__PURE__ */ e(
            v.Item,
            {
              label: d("en-US", "passwordLabel"),
              name: "password",
              rules: [
                {
                  required: !0,
                  message: d("en-US", "loginPasswordRequired")
                }
              ],
              children: /* @__PURE__ */ e(W.Password, {})
            }
          ),
          /* @__PURE__ */ e(E, { type: "primary", htmlType: "submit", block: !0, loading: n, children: d("en-US", "loginButton") })
        ]
      }
    )
  ] });
}, Eo = ({ onNext: t, loading: n }) => {
  const [r] = v.useForm(), o = (i) => {
    t(i);
  };
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ e("h2", { children: d("en-US", "mfaPhoneHeading") }),
    /* @__PURE__ */ c(v, { form: r, layout: "vertical", onFinish: o, children: [
      /* @__PURE__ */ e(
        v.Item,
        {
          label: d("en-US", "phoneNumberLabel"),
          name: "phoneNumber",
          rules: [
            {
              required: !0,
              message: d("en-US", "mfaPhoneRequired")
            }
          ],
          children: /* @__PURE__ */ e(W, { placeholder: d("en-US", "phoneNumberPlaceholder") })
        }
      ),
      /* @__PURE__ */ e(v.Item, { label: d("en-US", "mfaSecretLabel"), name: "secret", rules: [], children: /* @__PURE__ */ e(W, { placeholder: d("en-US", "mfaSecretPlaceholder") }) }),
      /* @__PURE__ */ e(E, { type: "primary", htmlType: "submit", block: !0, loading: n, children: d("en-US", "sendCodeButton") })
    ] })
  ] });
}, Fo = ({ onVerify: t, loading: n }) => {
  const [r] = v.useForm(), o = (i) => {
    t(i.code);
  };
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ e("h2", { children: d("en-US", "mfaCodeHeading") }),
    /* @__PURE__ */ c(v, { form: r, layout: "vertical", onFinish: o, children: [
      /* @__PURE__ */ e(
        v.Item,
        {
          label: d("en-US", "mfaCodeLabel"),
          name: "code",
          rules: [{ required: !0, message: d("en-US", "mfaCodeRequired") }],
          children: /* @__PURE__ */ e(W, { placeholder: d("en-US", "mfaPlaceholderCode") })
        }
      ),
      /* @__PURE__ */ e(E, { type: "primary", htmlType: "submit", block: !0, loading: n, children: d("en-US", "verifyButton") })
    ] })
  ] });
};
function bt(t) {
  return typeof t == "object" && t !== null && t.isAxiosError === !0;
}
function Po(t) {
  switch (t) {
    case "ACCOUNT":
      return 0;
    case "LOGIN":
      return 1;
    case "MFA_PHONE":
      return 2;
    case "MFA_CODE":
      return 3;
    case "DONE":
      return 4;
  }
}
const Oi = () => {
  const { token: t } = Y.useToken(), { message: n } = Se.useApp(), [r, o] = L("ACCOUNT"), [i, l] = L(""), [u, a] = L(null), { register: s, loading: m } = _t(), { login: h, loading: g } = Tt(), { registerSmsMfa: _, loading: C } = An(), { verifySmsMfa: f, loading: S } = Ln();
  async function b(H) {
    a(null);
    try {
      const x = await s(H);
      l(x.userId), n.success(d("en-US", "accountCreatedSuccess")), o("LOGIN");
    } catch (x) {
      bt(x) && x.response?.status === 409 ? a({
        message: d("en-US", "emailAlreadyExists"),
        fieldErrors: { email: d("en-US", "emailAlreadyExists") }
      }) : a({
        message: d("en-US", "registrationError")
      }), n.error(d("en-US", "accountCreateFailed"));
    }
  }
  async function I(H) {
    try {
      await h(H), n.success(d("en-US", "loginSuccess")), o("MFA_PHONE");
    } catch {
      n.error(d("en-US", "loginCheckError"));
    }
  }
  async function p(H) {
    try {
      await _(H), n.success(d("en-US", "mfaInitiatedSuccess")), o("MFA_CODE");
    } catch (x) {
      bt(x) && x.response?.status === 400 ? a({
        message: d("en-US", "invalidPhoneNumber"),
        fieldErrors: {
          phoneNumber: d("en-US", "invalidPhoneNumberField")
        }
      }) : a({
        message: d("en-US", "registerPhoneNumberError")
      }), n.error(d("en-US", "mfaPhoneError"));
    }
  }
  async function N(H) {
    try {
      await f({ userId: i, code: H }), n.success(d("en-US", "mfaVerifiedSuccess")), o("DONE");
    } catch {
      n.error(d("en-US", "mfaCodeError"));
    }
  }
  let q;
  return r === "ACCOUNT" ? q = /* @__PURE__ */ e(
    Mo,
    {
      onNext: b,
      loading: m,
      serverError: u
    }
  ) : r === "LOGIN" ? q = /* @__PURE__ */ e(Uo, { onLogin: I, loading: g }) : r === "MFA_PHONE" ? q = /* @__PURE__ */ e(Eo, { onNext: p, loading: C }) : r === "MFA_CODE" ? q = /* @__PURE__ */ e(Fo, { onVerify: N, loading: S }) : q = /* @__PURE__ */ e(Io, {}), /* @__PURE__ */ e(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: t.colorBgBase,
        padding: t.paddingLG
      },
      children: /* @__PURE__ */ c(
        Te,
        {
          style: {
            maxWidth: 600,
            width: "100%",
            padding: t.paddingMD,
            backgroundColor: t.colorBgContainer,
            boxShadow: t.boxShadow
          },
          children: [
            /* @__PURE__ */ e(
              et,
              {
                current: Po(r),
                style: { marginBottom: t.marginLG },
                items: [
                  { title: d("en-US", "registrationStepAccount") },
                  { title: d("en-US", "registrationStepLogin") },
                  { title: d("en-US", "registrationStepPhone") },
                  { title: d("en-US", "registrationStepCode") },
                  { title: d("en-US", "registrationStepDone") }
                ]
              }
            ),
            q
          ]
        }
      )
    }
  );
}, { Content: Bo } = ie, { Title: Ro, Text: $o } = F, zi = ({ user: t }) => {
  const n = typeof t.avatar == "string" ? t.avatar : void 0;
  return /* @__PURE__ */ e(ie, { style: { backgroundColor: "#f9f9f9" }, children: /* @__PURE__ */ c(Bo, { style: { padding: "40px 24px" }, children: [
    /* @__PURE__ */ e(Ye, { justify: "center", style: { textAlign: "center", marginBottom: 40 }, children: /* @__PURE__ */ c(Oe, { children: [
      /* @__PURE__ */ e(
        wt,
        {
          size: 96,
          src: n,
          style: { backgroundColor: "#1890ff", marginBottom: 16 },
          children: t.displayName.charAt(0)
        }
      ),
      /* @__PURE__ */ e(Ro, { level: 3, children: t.displayName }),
      /* @__PURE__ */ e($o, { type: "secondary", children: t.email })
    ] }) }),
    /* @__PURE__ */ e(Ye, { justify: "center", children: /* @__PURE__ */ e(Oe, { xs: 24, sm: 20, md: 16, lg: 12, children: /* @__PURE__ */ c(
      le,
      {
        bordered: !0,
        column: 1,
        layout: "vertical",
        style: { backgroundColor: "#fff", padding: 24, borderRadius: 12 },
        children: [
          /* @__PURE__ */ e(le.Item, { label: "Full Name", children: t.fullName || "N/A" }),
          /* @__PURE__ */ e(le.Item, { label: "Preferred Name", children: t.preferredName || "N/A" }),
          /* @__PURE__ */ e(le.Item, { label: "Given Name", children: t.givenName || "N/A" }),
          /* @__PURE__ */ e(le.Item, { label: "Family Name", children: t.familyName || "N/A" }),
          /* @__PURE__ */ e(le.Item, { label: "Status", children: t.active ? /* @__PURE__ */ e(he, { color: "green", children: "Active" }) : /* @__PURE__ */ e(he, { color: "red", children: "Inactive" }) }),
          /* @__PURE__ */ e(le.Item, { label: "Feature Flags", children: t.featureFlags?.length ? t.featureFlags.map((r) => /* @__PURE__ */ e(he, { color: "blue", children: r }, r)) : "None" })
        ]
      }
    ) }) })
  ] }) });
}, Wi = () => {
  const { toggleTheme: t } = Ct();
  return t;
}, qi = () => !Je.useBreakpoint().md, Hi = () => new Promise((t, n) => {
  if (!navigator.geolocation) {
    n(new Error("Geolocation is not supported by this browser."));
    return;
  }
  navigator.geolocation.getCurrentPosition(
    (r) => {
      const { latitude: o, longitude: i } = r.coords;
      t({ latitude: o, longitude: i });
    },
    (r) => {
      n(new Error(`Failed to get location: ${r.message}`));
    },
    {
      enableHighAccuracy: !0,
      timeout: 1e4,
      maximumAge: 0
    }
  );
});
function Vi() {
  const { message: t } = Se.useApp();
  return {
    success(n) {
      t.success(n);
    },
    error(n) {
      t.error(n);
    }
  };
}
export {
  ci as ActionFooter,
  si as AdminFooter,
  mi as AnalyticsFooter,
  Yi as AppThemeProvider,
  ki as BalanceWidget,
  ri as BreadcrumbComponent,
  Fi as Button,
  oi as CardUI,
  wi as ClassificationTree,
  ii as ContentWrapper,
  Mi as CsvDropzone,
  xi as CurrencyInput,
  er as CustomBarShape,
  Dt as DateRangePicker,
  Io as DoneScreen,
  It as Drawer,
  xe as FOOTER_MIN_HEIGHT,
  _i as FeatureUsageDashboard,
  li as FooterComponent,
  pi as HeaderComponent,
  Ti as InvoicePreviewModal,
  Ci as InvoiceTable,
  hi as LegalBar,
  Bi as Login,
  rt as LogoComponent,
  $i as Logout,
  Fn as MarketingFooter,
  Ui as MemberSignupWidget,
  ce as MoneyField,
  bi as PriceScheduleCreateWizard,
  Si as PriceScheduleEditModal,
  yi as PriceScheduleTimeline,
  Ii as ProductVariantModal,
  ir as RANGE_ERROR_END_AFTER_START,
  ar as RANGE_ERROR_OVERLAP,
  Ri as Register,
  Oi as RegistrationWizard,
  Nt as SAFE_AREA_INSET_BOTTOM,
  gi as SidebarComponent,
  xr as SignupForm,
  We as StatusChip,
  Mo as StepAccountForm,
  Fo as StepMfaCodeForm,
  Eo as StepMfaPhoneForm,
  Ni as SystemHealthWidget,
  di as TableFooterBar,
  fi as TagChip,
  ui as TenantFooter,
  Ai as TenantOnboardingWizard,
  Ei as TextInput,
  Pi as ThemeToggle,
  zi as UserProfilePage,
  Di as WebBrandingProvider,
  Re as cloneDataNodes,
  Et as filterTree,
  Qe as findNode,
  we as findParent,
  vi as flatten,
  ot as formatCurrency,
  ve as fromDataNode,
  Hi as getBrowserLocation,
  ai as getSafeAreaPaddingBottom,
  gt as indentNode,
  Be as maxDepth,
  pt as moveNodeDown,
  ht as moveNodeUp,
  ft as outdentNode,
  Xe as removeNode,
  Ke as toDataNode,
  Mt as updateTitle,
  Sr as useCreateTenantMutation,
  qi as useIsMobile,
  Vi as useNotifications,
  Wi as useThemeToggle,
  Li as useWebBranding
};
//# sourceMappingURL=index.js.map
